<template>
<div style="
  position: relative;
  ">
  <div
    v-if="isMobile"
    style="
      width: 1667px;
      height: 879px;
      background-image: url('../../static/images/bg.jpg');
      background-size: 100%;
      background-repeat: no-repeat;
      position: relative;
    "
    @click="SH()"
  >
   <img src="/../../static/images/icon/arrows1.gif"
      v-if="mibeeOnline &&dehum&&dehum.power"
      style="
        width:498px;
        z-index: 1;
        position: absolute;
        top: 149px;
        left: 590px"/>
    <el-alert
      v-if="!mibeeOnline"
      :title="errortext"
      type="error"
      :closable="false"
      effect="dark"
      show-icon
    >
    </el-alert>
    <div
      style="
        color: #ffffff;
        font-size: 16px;
        position: absolute;
        top: 53px;
        left: 260px;
      "
    >
      室内环境
    </div>
    <div
      style="
        color: #ffffff;
        font-size: 16px;
        position: absolute;
        top: 53px;
        left: 760px;
      "
    >
      数字暖通AIO系统空调
      <span v-if="!qlg.online" style="color: red; font-size: 12px">离线</span>
    </div>
    <div
      v-if="false"
      style="
        color: red;
        font-size: 14px;
        position: absolute;
        top: 30px;
        left: 1290px;
      "
    >
      <i class="el-icon-warning"></i> 主机离线，最后更新时间：<span
        style="color: #929292"
        >{{ uploadtime || qlg.uploadtime }}</span
      >
    </div>
    <div
      style="
        color: #ffffff;
        font-size: 16px;
        position: absolute;
        top: 308px;
        left: 1522px;
      "
    >
      <span v-if="!heatpump.online" style="color: red; font-size: 12px"
        >热泵离线</span
      >
    </div>
    <div
      class="elbutton"
      style="
        color: #15d04c;
        font-size: 12px;
        position: absolute;
        top: 110px;
        left: 1170px;
        cursor: pointer;
        width: 380px;
      "
    >
      <el-row>
        <el-col :span="6" style="text-align: left">耗电监控</el-col>
        <!-- <el-col :span="6" class="value_big_1">kw·h</el-col> -->
      </el-row>
    </div>
    <div
      v-if="!(project.aiodp&&project.aiodp.indexOf('acb')>=0)"
      style="
        color: #ffffff;
        font-size: 12px;
        position: absolute;
        top: 130px;
        left: 1170px;
        text-align: left;
        line-height: 20px;
        width: 380px;
      "
    >
      <el-col :span="6" class="text_big">昨日耗电</el-col>
      <el-col :span="4" :offset="2" class="value_big">{{qlg.yestec||(power.length>=2?Math.round(power[0].powerused):0) }}度</el-col>
      <el-col :span="5" :offset="2" class="text_big">当前功率</el-col>
      <el-col :span="4" :offset="1" class="value_big">{{ heatpump.reg0031||(Math.round(acb.voltage*acb.elecrt/100)/10)||0 }}kW</el-col>
      <el-col :span="6" class="text_big">今日耗电</el-col>
      <el-col :span="4" :offset="2" class="value_big">{{qlg.todayec||( power.length>=2?Math.round(power[1].powerused):0) }}度</el-col>
      <el-col :span="5" :offset="2" class="text_big">当前电流</el-col>
      <el-col :span="4" :offset="1" class="value_big"
        >{{ heatpump.reg0028||acb.elecrt||0 }}A</el-col
      >
    </div>
    <div v-else
        style="
        color: #ffffff;
        font-size: 12px;
        position: absolute;
        top: 136px;
        left: 1170px;
        text-align: left;
        line-height: 20px;
        width: 380px;
      "
    >
      <el-col :span="8"  class="text_big">未添加相关传感器</el-col>
    </div>
    <div
      style="
        color: #15d04c;
        font-size: 12px;
        position: absolute;
        top: 60px;
        left: 1170px;
      "
    >
      气象站
    </div>
    <div
      style="
        color: #ffffff;
        font-size: 12px;
        position: absolute;
        top: 50px;
        left: 1220px;
        height: 120px;
        line-height: 20px;
        text-align: left;
        width: 360px;
      "
    >
      <el-col :span="4" class="text_big">室外温度</el-col>
      <el-col :span="2" class="value_big">{{ outtemp }}℃</el-col>
      <el-col :span="4" :offset="1" class="text_big">室外湿度</el-col>
      <el-col :span="2" class="value_big">{{ outhumid }}%</el-col>
      <el-col :span="4" :offset="1" class="text_big">含湿量</el-col>
      <el-col :span="4" class="value_big"
        >{{ calcHsl(outtemp, outhumid) }}g/Kg</el-col
      >
      <el-col :span="4" class="text_big">空气焓值</el-col>
      <el-col :span="4" class="value_big"
        >{{ calcHanZhi(outtemp, outhumid) }}Kj/Kg</el-col
      >
      <el-col :span="5" :offset="3" class="text_big">空气质量指数</el-col>
      <el-col :span="6"  class="value_big"
        >{{ aqi }} ({{ aqilevel }})</el-col
      >
    </div>

    <div
      style="
        color: #15d04c;
        font-size: 12px;
        position: absolute;
        top: 212px;
        left: 1190px;
      "
    >
      系统状态
    </div>
    <div
      style="
        color: red;
        font-size: 14px;
        position: absolute;
        top: 800px;
        left: 1310px;
        height: 20px;
        line-height: 20px;
      "
      class="el-icon-warning"
      v-if="heatpump.errmsg"
    >
      {{ heatpump.errmsg }}
    </div>
    <el-row
      style="
        position: absolute;
        top: 803px;
        left: 1178px;
        width:auto;
        color:#B3B3B3;
        border: 0;
        font-size:12px;
        cursor: pointer;
      "
      @click.native="openError()"
      >故障信息</el-row
    >
    <div
      style="
        color: #15d04c;
        font-size: 12px;
        position: absolute;
        top: 308px;
        left: 1190px;
      "
    >
      输配工况
    </div>
    <el-dropdown v-if="qlgList.length>1" @command="qlgChange" style="font-size: 12px;color:#929292;position: absolute;top: 308px;left: 1245px;cursor: pointer;" trigger="click">
  <span class="el-dropdown-link">
    {{qlg.name}}<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
  <el-dropdown-menu slot="dropdown" >
    <el-dropdown-item :key="item.innerid" :command="item" v-for="item in qlgList" style="font-size:12px">{{item.name}}</el-dropdown-item>

  </el-dropdown-menu>
</el-dropdown>
<el-dropdown v-if="heatpumpList.length>1" @command="heatpumpChange" style="font-size: 12px;color:#929292;position: absolute;top: 308px;left: 1395px;cursor: pointer;" trigger="click">
  <span class="el-dropdown-link">
    {{heatpump.name}}<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
  <el-dropdown-menu slot="dropdown" >
    <el-dropdown-item :key="item.innerid" :command="item" v-for="item in heatpumpList" style="font-size:12px">{{item.name}}</el-dropdown-item>

  </el-dropdown-menu>
</el-dropdown>
     <!-- <div
      style="
        color: #15d04c;
        font-size: 12px;
        position: absolute;
        top: 379px;
        left: 1375px;
      "
    >
      热泵工况
    </div> -->
    <div
      style="
        font-size: 12px;
        width: 380px;
        position: absolute;
        top: 478px;
        left: 1190px;
      "
    >
      <el-row>
        <el-col :span="5" style="color: #15d04c; text-align: left;">
          美赑云端运维
        </el-col>
        <el-col :span="3" class="value_big_1">
          参考值
        </el-col>
        <el-col :span="10" class="value_big_1"></el-col>
        <el-col :span="3" class="value_big_1">
          参考值
        </el-col>
      </el-row>
    </div>
    <div
      v-if="!!!dehum.outfanspd || !mibeeOnline || !!!dehum.power"
      style="
        z-index: 1;
        position: absolute;
        width: 25px;
        height: 25px;
        top: 286px;
        left: 786px;
        background: url('../../static/images/icon/stopfanset.png');
        background-size: 100% 100%;
      "
    ></div>
    <div
      v-else
      style="
        z-index: 1;
        position: absolute;
        width: 25px;
        height: 25px;
        top: 286px;
        left: 786px;
        background: url('../../static/images/icon/runfanset.gif');
        background-size: 100% 100% !important;
      "
    ></div>
    <div
      v-if="!!!dehum.outfanspd || !mibeeOnline || !!!dehum.power"
      style="
        z-index: 1;
        position: absolute;
        width: 25px;
        height: 25px;
        top: 286px;
        left: 786px;
      "
    ></div>
    <div
      v-else
      style="
        z-index: 1;
        position: absolute;
        width: 498px;
        height: 190px;
        top: 156px;
        left: 592px;
        background: url('../../static/images/icon/left.gif');
        background-size: 100% 100% !important;
      "
    ></div>
    <div
      v-if="!!!dehum.infanspd || !mibeeOnline || !!!dehum.power"
      style="
        z-index: 1;
        position: absolute;
        width: 25px;
        height: 25px;
        top: 286px;
        left: 944px;
        background: url('../../static/images/icon/stopfanset.png');
        background-size: 100% 100%;
      "
    ></div>
    <div
      v-else
      style="
        z-index: 1;
        position: absolute;
        width: 25px;
        height: 25px;
        top: 286px;
        left: 944px;
        background: url('../../static/images/icon/runfanset.gif');
        background-size: 100% 100% !important;
      "
    ></div>
    <div
      v-if="!!!dehum.infanspd || !mibeeOnline || !!!dehum.power"
      style="
        z-index: 1;
        position: absolute;
        width: 25px;
        height: 25px;
        top: 286px;
        left: 944px;
      "
    ></div>
    <div
      v-else
      style="
        z-index: 1;
        position: absolute;
        width: 498px;
        height: 190px;
        top: 156px;
        left: 589px;
        background: url('../../static/images/icon/right.gif');
        background-size: 100% 100% !important;
      "
    ></div>
    <!-- <div style="width:1667px;height:880px; background: url('../../static/images/icon/stopfanset.png'); background-size: 100% 100%;"></div> -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 80px;
        left: 100px;
        width: 420px;
        height: 745px;
        text-align: left;
        overflow: hidden;
        overflow-y: auto;
      "
    >
      <el-col
        :span="24"
        style="
          position: relative;
          background: #141517;
          border-radius: 20px;
          height: 133.49px;
          margin-top: 10px;
        "
        v-for="item in devicelist.filter((x) => {
          return (
            x.protocolid == 228
          );
        })"
        :key="item.innerid"
      >
        <div
          style="
            color: #ffffff;
            font-size: 13px;
            position: relative;
            top: 0px;
            left: 0px;
            height: 41px;
            width: 100%;
            line-height: 41px;
            padding-left: 30px;
          "
        >
          {{ item.roomname }}
        </div>
        <div
          style="
            color: #15d04c;
            font-size: 12px;
            position: absolute;
            height:41px;
            line-height:41px;
            top: 0px;
            left: 250px;
          "
          v-if="item.devtype == 2"
        >
          风盘
        </div>
        <!-- <div
          style="
            color: #15d04c;
            font-size: 12px;
            position: absolute;
             top: 0px;
             height:41px;
            line-height:41px;
            left: 250px;
          "
          v-else
        >
          顶冷
        </div> -->

        <div
          class="value"
          style="
            font-size: 12px;
            position: absolute;
            top: 0px;
            left: 280px;
             height:41px;
            line-height:41px;
            text-align: center;
          "
          v-if="item.devtype == 2"
        >
          {{ item.ecfanrun?(item.ecfanrun+'%'):'停止' }}
        </div>
        <!-- <div
          class="value"
          style="
            font-size: 12px;
            position: absolute;
            top: 0px;
           left: 280px;
             height:41px;
            line-height:41px;
            text-align: center;
          "
          v-else
        >
          {{ item.fsvalneed?'通':'断'  }}
        </div> -->

        <div
          style="
            color: #15d04c;
            font-size: 12px;
            position: absolute;
            top: 0px;
            left: 310px;
              height:41px;
            line-height:41px;
          "
        >
          控制器
        </div>
           <div
          class="value"
          v-if="!item.online"
          style="
            font-size: 12px;
            position: absolute;
            top: 0px;
            color: red;
            left: 350px;
            width: 40px;
            text-align: center;
             height:41px;
            line-height:41px;
          "
        >
          离线
        </div>
        <div
        v-else
          class="value"
          style="
            font-size: 12px;
            position: absolute;
            top: 0px;
            left: 350px;
            width: 40px;
            text-align: center;
             height:41px;
            line-height:41px;
          "
        >
          {{ getDpText(item, "power") }}
        </div>
        <div
          style="
            position: relative;
            background: #000002;
            width: 90%;
            height: 82.28px;
            left: 5%;
            border-radius: 20px;
          "
        >
          <el-row
            style="
              position: absolute;
              top: 15px;
              left: 10px;
              width: 155px;
              height: 80px;
              text-align: left;
            "
          >
            <el-col :span="11" class="text_big">设定温度</el-col>
            <el-col :span="9" :offset="1" class="value_big"
              >{{ item.settemp.toFixed(1) }}℃</el-col
            >
            <el-col :span="11" class="text_big">室内温度</el-col>
            <el-col :span="9" :offset="1" class="value_big"
              >{{ item.temp.toFixed(1) }}℃</el-col
            >
            <el-col :span="11" class="text_big">露点温度</el-col>
            <el-col :span="9" :offset="1" class="value_big"
              >{{ item.dewtemp.toFixed(1) }}℃</el-col
            >
          </el-row>
          <el-row
            style="
              position: absolute;
              top: 15px;
              left: 215px;
              width: 155px;
              height: 80px;
              text-align: left;
            "
          >
            <el-col :span="9" class="text_big">湿度</el-col>
            <el-col :span="11" :offset="1" class="value_big"
              >{{ item.snrhumi }}%</el-col
            >
            <el-col :span="9" class="text_big">湿量</el-col>
            <el-col :span="11" :offset="1" class="value_big">
              {{ calcHsl(item.temp, item.snrhumi) }}g/Kg</el-col
            >
            <el-col :span="9" class="text_big">焓值</el-col>
            <el-col :span="11" :offset="1" class="value_big"
              >{{ calcHanZhi(item.temp, item.snrhumi) }}kJ/kg</el-col
            >
          </el-row>
        </div>
      </el-col>
    </el-row>

    <!-- 系统参数 -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 236px;
        left: 1190px;
        width: 380px;
        height: 45px;
        text-align: left;
      "
    >
      <el-col :span="7" class="text_big">系统状态</el-col>
      <el-col :span="3" :offset="1" class="value_big">{{
        getDpText(qlg, "power")
      }}</el-col>
      <el-col :span="6" :offset="2" class="text_big">模式设置</el-col>
      <el-col :span="4" :offset="1" class="value_big">{{
        getDpText(qlg, "mode")
      }}</el-col>
      <el-col v-if="false" :span="6" class="text_big">热水开关</el-col>
      <el-col v-if="false" :span="4" :offset="1" class="value_big">{{
        getDpText(heatpump, "hotwater")
      }}</el-col>
      <el-col v-if="false" :span="7" :offset="2" class="text_big">生活热水设置温度</el-col>
      <el-col v-if="false" :span="3" :offset="1" class="value_big"
        >{{ heatpump.settemp_hx }}℃</el-col
      >
      <el-col :span="7" class="text_big">相对湿度设置</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ qlg.sethumi }}%</el-col
      >
    </el-row>
    <!-- 输配 -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 328px;
        left: 1190px;
        width: 380px;
        height: 145px;
        text-align: left;
      "
    >
      <el-col :span="6" class="text_big">模式</el-col>
      <el-col :span="4" :offset="1" class="value_big">{{
        getDpText(qlg, "mode")
      }}</el-col>
      <!-- <el-col  :span="6" :offset="1" class="text_big">供水压力</el-col>
      <el-col  :span="4" :offset="1" class="value_big">--</el-col> -->
      <el-col  :span="6" :offset="2" class="text_big">运行状态</el-col>
      <el-col  :span="4" :offset="1" class="value_big">{{getDpText(heatpump, "power")}}</el-col>
      <!-- <el-col  :span="6" :offset="2" class="text_big">吸气过热度</el-col>
      <el-col  :span="4" :offset="1" class="value_big">{{ heatpump.zxqgr || '--' }}K</el-col> -->
      <el-col :span="7" class="text_big">一次供水</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ qlg.spjstemp }}℃</el-col
      >
      <!-- <el-col :span="7" :offset="2" class="text_big">吸气温度</el-col>
      <el-col :span="3" :offset="1" class="value_big">{{heatpump.reg0041 || '--'}}℃</el-col
      > -->
      <el-col :span="7" :offset="2" class="text_big">母线电压</el-col>
      <el-col :span="3" :offset="1" class="value_big">{{heatpump.reg0070 || '--'}}V</el-col>
        <!-- <el-col  :span="7" :offset="1" class="text_big">回水压力</el-col>
      <el-col   :span="3" :offset="1" class="value_big"
        >--</el-col> -->
      <el-col :span="7" class="text_big">一次回水</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ qlg.hphstemp }}℃</el-col
      >
      <el-col :span="7" :offset="2" class="text_big">制热设置温度</el-col>
      <el-col :span="3" :offset="1" class="value_big">{{ heatpump.settemp_ho }}℃</el-col>
      <!-- <el-col :span="7" :offset="2" class="text_big">进水温度</el-col>
      <el-col :span="3" :offset="1" class="value_big">{{ heatpump.temp_b || '--' }}℃</el-col
      > -->
      <el-col :span="7" class="text_big">二次供水</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ qlg.mixtemp }}℃</el-col
      >
      <el-col :span="7" :offset="2" class="text_big">制冷设置温度</el-col>
      <el-col :span="3" :offset="1" class="value_big">{{ heatpump.settemp_co }}℃</el-col
      >
      <!-- <el-col :span="7" :offset="2" class="text_big">环境温度</el-col>
      <el-col :span="3" :offset="1" class="value_big">{{ heatpump.temp || '--' }}℃</el-col
      > -->
      <el-col :span="7" class="text_big">二次回水</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{ qlg.sphstemp }}℃</el-col
      >
      <el-col :span="7" :offset="2" class="text_big">循环水泵</el-col>
      <el-col :span="3" :offset="1" class="value_big">{{getDpText(heatpump, "reg0014")}}</el-col
      >
      <el-col :span="7" class="text_big">水泵状态</el-col>
      <el-col :span="3" :offset="1" class="value_big"
        >{{   getDpText(qlg, "spsbzt") }}</el-col
      >
      <el-col :span="7" :offset="2" class="text_big">压缩机频率</el-col>
      <el-col :span="3" :offset="1" class="value_big">{{ heatpump.cfrequency }}Hz</el-col
      >
      <!-- <el-col :span="7" :offset="2" class="text_big">制冷出水温度</el-col>
      <el-col :span="3" :offset="1" class="value_big">{{ heatpump.settemp_co }}Hz</el-col
      > -->

    </el-row>
    <!-- 美赑云端运维 -->
    <el-row v-if="qlg.mode == 1" style="
        font-size: 12px;
        position: absolute;
        top: 500px;
        left: 1190px;
        width: 380px;
        height: 165px;
        text-align: left;
      ">
      <el-col :span="5" class="text_big">环境温度</el-col>
      <el-col :span="3" class="value_big_1">
        15~45
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.temp > 45" class="el-icon-top"></i>
        <i v-show="heatpump.temp < 15" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.temp || '--' }}℃
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">驱动模块</el-col>
      <el-col :span="3" class="value_big_1">
        0~85
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.moduletemp > 85" class="el-icon-top"></i>
        <i v-show="heatpump.moduletemp < 0" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.moduletemp || '--' }}℃
      </el-col>
      <el-col :span="5" class="text_big">进水温度</el-col>
      <el-col :span="3" class="value_big_1">
        10~30
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.temp_b > 30" class="el-icon-top"></i>
        <i v-show="heatpump.temp_b < 10" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.temp_b || '--' }}℃
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">吸气压力</el-col>
      <el-col :span="3" class="value_big_1">
        7~12
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.xqpressure > 12" class="el-icon-top"></i>
        <i v-show="heatpump.xqpressure < 7" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.xqpressure || '--' }}bar
      </el-col>
      <el-col :span="5" class="text_big">出水温度</el-col>
      <el-col :span="3" class="value_big_1">
        5~20
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.temp_o > 20" class="el-icon-top"></i>
        <i v-show="heatpump.temp_o < 5" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.temp_o || '--' }}℃
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">吸气过热度</el-col>
      <el-col :span="3" class="value_big_1">
        2~20
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.zxqgr > 20" class="el-icon-top"></i>
        <i v-show="heatpump.zxqgr < 2" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.zxqgr || '--' }}K
      </el-col>
      <el-col :span="5" class="text_big">进出温差</el-col>
      <el-col :span="3" class="value_big_1">
        2~9
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="temp_b_o > 9" class="el-icon-top"></i>
        <i v-show="temp_b_o < 2" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ temp_b_o }}℃
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">排气过热度</el-col>
      <el-col :span="3" class="value_big_1">
        15~45
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.pxgr > 45" class="el-icon-top"></i>
        <i v-show="heatpump.pxgr < 15" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.pxgr || '--' }}K
      </el-col>
      <el-col :span="5" class="text_big">排气温度</el-col>
      <el-col :span="3" class="value_big_1">
        45~105
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.pqtemp > 105" class="el-icon-top"></i>
        <i v-show="heatpump.pqtemp < 45" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{heatpump.pqtemp || '--'}}℃
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">经济器过热度</el-col>
      <el-col :span="3" class="value_big_1">
      </el-col>
      <el-col :span="1" class="value_big">
      </el-col>
      <el-col :span="2" class="value_big value_big_2" >
        {{ heatpump.fjjqgr||heatpump.fjjqgr==0?heatpump.fjjqgr:'--' }}℃
      </el-col>
      <el-col :span="5" class="text_big">中盘温度</el-col>
      <el-col :span="3" class="value_big_1">
        45~62
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.zptemp > 62" class="el-icon-top"></i>
        <i v-show="heatpump.zptemp < 45" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{heatpump.zptemp || '--'}}℃
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">主膨胀阀步数</el-col>
      <el-col :span="4" class="value_big_1"></el-col>
      <el-col :span="2" class="value_big value_big_2" v-if="heatpump.reg0065 > 0 || heatpump.reg0065 <= 0">
        {{ heatpump.reg0065 }}PPS
      </el-col>
      <el-col :span="2" class="value_big value_big_2" v-else>
        {{'-'}}PPS
      </el-col>
      <el-col :span="5" class="text_big">出盘温度</el-col>
      <el-col :span="4"  class="value_big_1"></el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{heatpump.reg0044 || '--'}}℃
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">辅膨胀阀步数</el-col>
      <el-col :span="4" class="value_big_1"></el-col>
      <el-col :span="2" class="value_big value_big_2" v-if="heatpump.reg0066 > 0 || heatpump.reg0066 <= 0">
        {{ heatpump.reg0066 }}PPS
      </el-col>
      <el-col :span="2" class="value_big value_big_2" v-else>
        {{'-'}}PPS
      </el-col>
      <el-col   :span="5" class="text_big">经济器进口</el-col>
      <el-col :span="3" class="value_big_1">
        10~50
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.reg0045 > 50" class="el-icon-top"></i>
        <i v-show="heatpump.reg0045 < 10" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2" v-if="heatpump.reg0045 > 0 || heatpump.reg0045 <= 0">
        {{heatpump.reg0045}}℃
      </el-col>
      <el-col :span="2" class="value_big value_big_2" v-else>
        {{'--'}}℃
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">空调循环泵</el-col>
      <el-col :span="3" class="value_big_1">

      </el-col>
      <el-col :span="1" class="value_big">
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ getDpText(heatpump, "reg0014") || '--' }}
      </el-col>
      <el-col :span="5" class="text_big">经济器出口</el-col>
      <el-col :span="3" class="value_big_1">
        25~55
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.reg0046 > 55" class="el-icon-top"></i>
        <i v-show="heatpump.reg0046 < 25" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2" v-if="heatpump.reg0046 > 0 || heatpump.reg0046 <= 0">
        {{heatpump.reg0046}}℃
      </el-col>
      <el-col :span="2" class="value_big value_big_2" v-else>
        {{'--'}}℃
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">压缩机频率</el-col>
      <el-col :span="4" class="value_big_1"></el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.cfrequency }}Hz
      </el-col>
      <el-col :span="5" class="text_big">吸气温度</el-col>
      <el-col :span="3" class="value_big_1">
        <!-- 15~45 -->
      </el-col>
      <el-col :span="1" class="value_big">
        <!-- <i v-show="heatpump.reg0041 > 45" class="el-icon-top"></i>
        <i v-show="heatpump.reg0041 < 15" class="el-icon-bottom"></i> -->
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{heatpump.reg0041 || '--'}}℃
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">风机1转速</el-col>
      <el-col :span="4" class="value_big_1"></el-col>
      <el-col :span="2" class="value_big value_big_2" v-if="heatpump.reg0049 > 0 || heatpump.reg0049 <= 0">
        {{ heatpump.reg0049 }}RPM
      </el-col>
      <el-col :span="2" class="value_big value_big_2" v-else>
        {{'--'}}
      </el-col>
      <el-col :span="11" class="text_big"></el-col>
      <el-col :span="5" :offset="2" class="text_big">风机2转速</el-col>
      <el-col :span="4" class="value_big_1"></el-col>
      <el-col :span="2" class="value_big value_big_2" v-if="heatpump.reg0050 > 0 || heatpump.reg0050 <= 0">
        {{ heatpump.reg0050 }}RPM
      </el-col>
      <el-col :span="2" class="value_big value_big_2" v-else>
        {{'--'}}
      </el-col>
      <el-col :span="11" class="text_big"></el-col>
      <el-col :span="5" :offset="2" class="text_big">压缩机电流</el-col>
      <el-col :span="4" class="value_big_1"></el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.compel || '--' }}A
      </el-col>
      <el-col :span="11" class="text_big"></el-col>
      <el-col :span="5" :offset="2" class="text_big">机组电流</el-col>
      <el-col :span="4" class="value_big_1"></el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ '--' }}A
      </el-col>

    </el-row>
    <el-row v-else
      style="
        font-size: 12px;
        position: absolute;
        top: 500px;
        left: 1190px;
        width: 380px;
        height: 165px;
        text-align: left;
      "
    >

      <el-col :span="5" class="text_big">环境温度</el-col>
      <el-col :span="3" class="value_big_1">
        -20~30
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.temp > 30" class="el-icon-top"></i>
        <i v-show="heatpump.temp < -20" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.temp || '--' }}℃
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">驱动模块</el-col>
      <el-col :span="3" class="value_big_1">
        0~85
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.moduletemp > 85" class="el-icon-top"></i>
        <i v-show="heatpump.moduletemp < 0" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.moduletemp || '--' }}℃
      </el-col>
      <el-col :span="5" class="text_big">进水温度</el-col>
      <el-col :span="3" class="value_big_1">
        10~50
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.temp_b > 50" class="el-icon-top"></i>
        <i v-show="heatpump.temp_b < 10" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.temp_b || '--' }}℃
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">吸气压力</el-col>
      <el-col :span="3" class="value_big_1">
        1.5~9
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.xqpressure > 9" class="el-icon-top"></i>
        <i v-show="heatpump.xqpressure < 1.5" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.xqpressure || '--' }}bar
      </el-col>
      <el-col :span="5" class="text_big">出水温度</el-col>
      <el-col :span="3" class="value_big_1">
        25~55
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.temp_o > 55" class="el-icon-top"></i>
        <i v-show="heatpump.temp_o < 25" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.temp_o || '--' }}℃
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">吸气过热度</el-col>
      <el-col :span="3" class="value_big_1">
        2~20
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.zxqgr > 20" class="el-icon-top"></i>
        <i v-show="heatpump.zxqgr < 2" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.zxqgr || '--' }}K
      </el-col>
      <el-col :span="5" class="text_big">进出温差</el-col>
      <el-col :span="3" class="value_big_1">
        2~9
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="temp_b_o > 9" class="el-icon-top"></i>
        <i v-show="temp_b_o < 2" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ temp_b_o }}℃
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">排气过热度</el-col>
      <el-col :span="3" class="value_big_1">
        15~45
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.pxgr > 45" class="el-icon-top"></i>
        <i v-show="heatpump.pxgr < 15" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.pxgr || '--' }}K
      </el-col>
      <el-col :span="5" class="text_big">排气温度</el-col>
      <el-col :span="3" class="value_big_1">
        45~110
      </el-col>
      <el-col :span="1" class="value_big">
        <i v-show="heatpump.pqtemp > 110" class="el-icon-top"></i>
        <i v-show="heatpump.pqtemp < 45" class="el-icon-bottom"></i>
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{heatpump.pqtemp || '--'}}℃
      </el-col>

      <el-col :span="5" :offset="2" class="text_big">吸气温度</el-col>
      <el-col :span="3" class="value_big_1">
        <!-- 15~45 -->
      </el-col>
      <el-col :span="1" class="value_big">
        <!-- <i v-show="heatpump.reg0041 > 45" class="el-icon-top"></i>
        <i v-show="heatpump.reg0041 < 15" class="el-icon-bottom"></i> -->
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{heatpump.reg0041 || '--'}}℃
      </el-col>
      <el-col :span="5" class="text_big">中盘温度</el-col>
      <el-col :span="3" class="value_big_1">

      </el-col>
      <el-col :span="1" class="value_big">
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{heatpump.zptemp || '--'}}℃
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">主膨胀阀步数</el-col>
      <el-col :span="4" class="value_big_1"></el-col>
      <el-col :span="2" class="value_big value_big_2" v-if="heatpump.reg0065 > 0 || heatpump.reg0065 <= 0">
        {{ heatpump.reg0065 }}PPS
      </el-col>
      <el-col :span="2" class="value_big value_big_2" v-else>
        {{'-'}}PPS
      </el-col>
      <el-col :span="5" class="text_big">出盘温度</el-col>
      <el-col :span="4"  class="value_big_1"></el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{heatpump.reg0044 || '--'}}℃
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">辅膨胀阀步数</el-col>
      <el-col :span="4" class="value_big_1"></el-col>
      <el-col :span="2" class="value_big value_big_2" v-if="heatpump.reg0066 > 0 || heatpump.reg0066 <= 0">
        {{ heatpump.reg0066 }}PPS
      </el-col>
      <el-col :span="2" class="value_big value_big_2" v-else>
        {{'-'}}PPS
      </el-col>
  
      <el-col :span="5"  class="text_big">空调循环泵</el-col>
      <el-col :span="3" class="value_big_1">

      </el-col>
      <el-col :span="1" class="value_big">
      </el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ getDpText(heatpump, "reg0014") || '--' }}
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">压缩机电流</el-col>
      <el-col :span="4" class="value_big_1"></el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.compel || '--' }}A
      </el-col>
  
      <el-col :span="5" class="text_big">压缩机频率</el-col>
      <el-col :span="4" class="value_big_1"></el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ heatpump.cfrequency }}Hz
      </el-col>
      <el-col :span="5"  :offset="2" class="text_big">机组电流</el-col>
      <el-col :span="4" class="value_big_1"></el-col>
      <el-col :span="2" class="value_big value_big_2">
        {{ '--' }}A
      </el-col>
      <el-col :span="5"  class="text_big">风机1转速</el-col>
      <el-col :span="4" class="value_big_1"></el-col>
      <el-col :span="2" class="value_big value_big_2" v-if="heatpump.reg0049 > 0 || heatpump.reg0049 <= 0">
        {{ heatpump.reg0049 }}RPM
      </el-col>
      <el-col :span="2" class="value_big value_big_2" v-else>
        {{'--'}}
      </el-col>
      <el-col :span="5" :offset="2" class="text_big">风机2转速</el-col>
      <el-col :span="4" class="value_big_1"></el-col>
      <el-col :span="2" class="value_big value_big_2" v-if="heatpump.reg0050 > 0 || heatpump.reg0050 <= 0">
        {{ heatpump.reg0050 }}RPM
      </el-col>
      <el-col :span="2" class="value_big value_big_2" v-else>
        {{'--'}}
      </el-col>
      <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('fjjqgr')>=0)" :span="5" class="text_big">经济器过热度</el-col>
      <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('fjjqgr')>=0)" :span="3" class="value_big_1">
        1~6
      </el-col>
      <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('fjjqgr')>=0)" :span="1" class="value_big">
        <i v-show="heatpump.fjjqgr > 6" class="el-icon-top"></i>
        <i v-show="heatpump.fjjqgr < 1" class="el-icon-bottom"></i>
      </el-col>
      <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('fjjqgr')>=0)" :span="2" class="value_big value_big_2">
        {{ heatpump.fjjqgr||heatpump.fjjqgr===0?heatpump.fjjqgr:'--' }}℃
      </el-col>
      <el-col  v-if="!(project.aiodp&&project.aiodp.indexOf('fjjqgr')>=0)" :span="11" class="text_big"></el-col>
     
      <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('reg0045')>=0)" :span="5" class="text_big">经济器进口</el-col>
      <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('reg0045')>=0)" :span="3" class="value_big_1">
        10~50
      </el-col>
      <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('reg0045')>=0)" :span="1" class="value_big">
        <i v-show="heatpump.reg0045 > 50" class="el-icon-top"></i>
        <i v-show="heatpump.reg0045 < 10" class="el-icon-bottom"></i>
      </el-col>
      <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('reg0045')>=0)" :span="2" class="value_big value_big_2">
        {{heatpump.reg0045||heatpump.reg0045==0?heatpump.reg0045:'--'}}℃
      </el-col>
      <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('reg0045')>=0)" :span="11" class="text_big"></el-col>
      <el-col   v-if="!(project.aiodp&&project.aiodp.indexOf('reg0046')>=0)" :span="5"  class="text_big">经济器出口</el-col>
      <el-col  v-if="!(project.aiodp&&project.aiodp.indexOf('reg0046')>=0)" :span="3" class="value_big_1">
        25~55
      </el-col>
      <el-col  v-if="!(project.aiodp&&project.aiodp.indexOf('reg0046')>=0)" :span="1" class="value_big">
        <i v-show="heatpump.reg0046 > 55" class="el-icon-top"></i>
        <i v-show="heatpump.reg0046 < 25" class="el-icon-bottom"></i>
      </el-col>
      <el-col  v-if="!(project.aiodp&&project.aiodp.indexOf('reg0046')>=0)" :span="2" class="value_big value_big_2">
        {{heatpump.reg0046||heatpump.reg0046===0?heatpump.reg0046:'--'}}℃
      </el-col>
    </el-row>

    <!-- 室外进风口 -->
    <el-row
      v-if="!(project.aiodp&&project.aiodp.indexOf('in')>=0)"
      style="
        font-size: 12px;
        position: absolute;
        top: 114px;
        left: 998px;
        width: 110px;
        height: 110px;
        text-align: left;
      "
    >
      <el-col :span="6"  class="text_big">温度</el-col>
      <el-col :span="17" class="value_big value_big_2" :offset="1">{{ dehum.retemp4 ||'--' }}℃</el-col>
      <el-col :span="6"  class="text_big"
        >湿度</el-col
      >
      <el-col :span="17" :offset="1" class="value_big value_big_2">{{ dehum.rehumi4 ||'--' }}%</el-col>
      <el-col :span="6"  class="text_big"
        >湿量</el-col
      >
      <el-col :span="17" :offset="1" class="value_big value_big_2"
        >{{ calcHsl(dehum.retemp4, dehum.rehumi4) }}g/Kg</el-col
      >
      <el-col :span="6"  class="text_big"
        >焓值</el-col
      >
      <el-col :span="17" :offset="1" class="value_big value_big_2"
        >{{ calcHanZhi(dehum.retemp4, dehum.rehumi4) }}Kj/Kg</el-col
      >
    </el-row>
    <el-row v-else
    class="text_big"
      style="
        font-size: 12px;
        position: absolute;
        top: 174px;
        left: 988px;
        width: 110px;
        height: 30px;
        text-align: left;
      ">
    未添加相关传感器
    </el-row>
    <!-- 室外排风口 -->
    <el-row
     v-if="!(project.aiodp&&project.aiodp.indexOf('out')>=0)"
      style="
        font-size: 12px;
        position: absolute;
        top: 316px;
        left: 998px;
        width: 110px;
        height: 110px;
        text-align: left;
      "
    >
      <el-col :span="6"  class="text_big">温度</el-col>
      <el-col :span="17" :offset="1" class="value_big value_big_2">{{ dehum.retemp5 ||'--' }}℃</el-col>
      <el-col :span="6"  class="text_big"
        >湿度</el-col
      >
      <el-col :span="17" :offset="1" class="value_big value_big_2">{{ dehum.rehumi5 ||'--' }}%</el-col>
      <el-col :span="6"  class="text_big"
        >湿量</el-col
      >
      <el-col :span="17" :offset="1" class="value_big value_big_2"
        >{{ calcHsl(dehum.retemp5, dehum.rehumi5) }}g/Kg</el-col
      >
      <el-col :span="6"  class="text_big"
        >焓值</el-col
      >
      <el-col :span="17" :offset="1" class="value_big value_big_2"
        >{{ calcHanZhi(dehum.retemp5, dehum.rehumi5) }}Kj/Kg</el-col>
    </el-row>
  <el-row v-else
   class="text_big"
  style="
        font-size: 12px;
        position: absolute;
        top: 314px;
        left: 988px;
        width: 365px;
        height: 30px;
        text-align: left;
      ">
    未添加相关传感器
  </el-row>
    <!-- 室内回风口 -->
    <div v-if="gdhn">
      <el-row v-show="!(project.aiodp&&project.aiodp.indexOf('roomout')>=0)"
        style="
          font-size: 12px;
          position: absolute;
          top: 105px;
          left: 670px;
          width: 90px;
          height: 60px;
          text-align: left;
        "
      >
        <el-col :span="8" class="text">温度</el-col>
        <el-col :span="13" :offset="1" class="value">{{ xfG4.innertemp ||'--' }}℃</el-col>
        <el-col :span="8" class="text">湿度</el-col>
        <el-col :span="13" :offset="1" class="value">{{ xfG4.innerhumid ||'--' }}%</el-col>
      </el-row>
      <el-row
        v-show="!(project.aiodp&&project.aiodp.indexOf('roomout')>=0)"
        style="
          font-size: 12px;
          position: absolute;
          top: 105px;
          left: 754px;
          width: 100px;
          height: 60px;
          text-align: left;
        "
      >
        <el-col :span="8" class="text">CO₂</el-col>
        <el-col :span="13" :offset="1" class="value">{{ xfG4.snrco2||'--' }}ppm</el-col>
        <el-col :span="8" class="text">PM2.5</el-col>
        <el-col :span="13" :offset="1" class="value"
          >{{ xfG4["snrpm2.5"]||'--' }}ug/m³</el-col
        >
      </el-row>
    </div>
    <div v-else>
      <el-row v-show="!(project.aiodp&&project.aiodp.indexOf('roomout')>=0)"
        style="
          font-size: 12px;
          position: absolute;
          top: 105px;
          left: 670px;
          width: 90px;
          height: 60px;
          text-align: left;
        "
      >
        <el-col :span="8" class="text">温度</el-col>
        <el-col :span="13" :offset="1" class="value">{{ dehum.snrtemp ||'--' }}℃</el-col>
        <el-col :span="8" class="text">湿度</el-col>
        <el-col :span="13" :offset="1" class="value">{{ dehum.snrhumi ||'--' }}%</el-col>
        <el-col :span="8" class="text">湿量</el-col>
        <el-col :span="13" :offset="1" class="value"
          >{{ calcHsl(dehum.snrtemp, dehum.snrhumi) }}g/Kg</el-col
        >
      </el-row>
      <el-row
        v-show="!(project.aiodp&&project.aiodp.indexOf('roomout')>=0)"
        style="
          font-size: 12px;
          position: absolute;
          top: 105px;
          left: 754px;
          width: 100px;
          height: 60px;
          text-align: left;
        "
      >
        <el-col :span="8" class="text">焓值</el-col>
        <el-col :span="13" :offset="1" class="value"
          >{{ calcHanZhi(dehum.snrtemp, dehum.snrhumi) }}Kj/Kg</el-col
        >
        <el-col :span="8" class="text">CO₂</el-col>
        <el-col :span="13" :offset="1" class="value">{{ dehum.snrco2||'--' }}ppm</el-col>
        <el-col :span="8" class="text">PM2.5</el-col>
        <el-col :span="13" :offset="1" class="value"
          >{{ dehum["snrpm2.5"]||'--' }}ug/m³</el-col
        >
      </el-row>
    </div>
    <!-- 出风风机 -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 254px;
        left: 783px;
        width: 100px;
        height: 60px;
        text-align: left;
      "
    >
      <el-col :span="24" class="value">{{ dehum.infanspd||0 }}</el-col>
    </el-row>
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 240px;
        left: 783px;
        width: 100px;
        height: 60px;
        text-align: left;
      "
    >
      <el-col :span="24" class="value">{{ getDpText(dehum,'infanrun') }}</el-col>
    </el-row>

    <!-- 进风风机 -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 254px;
        left: 879px;
        width: 90px;
        height: 60px;
        text-align: right;
      "
    >
      <el-col :span="24" class="value">{{ dehum.outfanspd||0 }}</el-col>
    </el-row>
 <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 240px;
        left: 876px;
        width: 90px;
        height: 60px;
        text-align: right;
      "
    >
      <el-col :span="24"  class="value">{{getDpText(dehum,'outfanrun') }}</el-col>
    </el-row>
      <!-- PTC状态 -->
    <el-row
    v-if="true"
      style="
        font-size: 12px;
        position: absolute;
        top: 372px;
        left: 748px;
        width: 110px;
        height: 60px;
        text-align: left;
      "
    >
      <el-col :span="11" class="text_big">PTC调温</el-col>
      <el-col :span="12" :offset="1" class="value_big value_big_2"
        >{{ getDpText(dehum,'ptcsta') }}</el-col
      >
      <!-- 进风温度-氟盘前温度/进风温度-回风温度 -->
      <el-col :span="11" class="text_big">除湿盘管</el-col>
      <el-col :span="12" :offset="1" class="value_big value_big_2"
        >{{ getDpText(dehum,'spjksta') }}</el-col>
    </el-row>

    <!-- 全热交换 -->
    <el-row
    v-if="!(project.aiodp&&(project.aiodp.indexOf('roomout')>=0||project.aiodp.indexOf('in')>=0||project.aiodp.indexOf('out')>=0))"
      style="
        font-size: 12px;
        position: absolute;
        top: 372px;
        left: 838px;
        width: 110px;
        height: 60px;
        text-align: left;
      "
    >
      <el-col :span="11" class="text_big">温度效率</el-col>
      <el-col :span="12" :offset="1" class="value_big value_big_2"
        >≥{{ calcRate(dehum.retemp4, dehum.intemp, dehum.snrtemp) }}%</el-col
      >
      <!-- 进风温度-氟盘前温度/进风温度-回风温度 -->
      <el-col :span="11" class="text_big">湿度效率</el-col>
      <el-col :span="12" :offset="1" class="value_big value_big_2"
        >≥{{
          calcRate(
            calcHsl(dehum.retemp4, dehum.rehumi4),
            calcHsl(dehum.intemp, dehum.inhumi),
            calcHsl(dehum.snrtemp, dehum.snrhumi)
          )
        }}%</el-col
      >
      <el-col :span="11" class="text_big">全热效率</el-col>
      <el-col :span="12" :offset="1" class="value_big value_big_2"
        >≥{{
          calcRate(
            calcHanZhi(dehum.retemp4, dehum.rehumi4),
            calcHanZhi(dehum.intemp, dehum.inhumi),
            calcHanZhi(dehum.snrtemp, dehum.snrhumi)
          )
        }}%</el-col
      >
    </el-row>
      <el-row
    v-else
      style="
        font-size: 12px;
        position: absolute;
        top: 372px;
        left: 838px;
        width: 110px;
        height: 60px;
        text-align: left;
      "
    >
      <el-col :span="11" class="text_big">温度效率</el-col>
      <el-col :span="12" :offset="1" class="value_big value_big_2"
        >≥85%</el-col>
      <!-- 进风温度-氟盘前温度/进风温度-回风温度 -->
      <el-col :span="11" class="text_big">湿度效率</el-col>
      <el-col :span="12" :offset="1" class="value_big value_big_2"
        >≥85%</el-col>
      <el-col :span="11" class="text_big">全热效率</el-col>
      <el-col :span="12" :offset="1" class="value_big value_big_2"
        >≥85%</el-col>
    </el-row>
    <!-- 室内新风口 -->
    <el-row v-show="!(project.aiodp&&project.aiodp.indexOf('roomin')>=0)"
      style="
        font-size: 12px;
        position: absolute;
        top: 372px;
        left: 660px;
        width: 110px;
        height: 60px;
        text-align: left;
      "
    >
      <el-col :span="6" class="text">风温</el-col>
      <el-col :span="17" :offset="1" class="value">{{ dehum.oftemp ||'--' }}℃</el-col>
      <el-col :span="6" class="text">露点</el-col>
      <el-col :span="17" :offset="1" class="value">{{ calcLuDian(dehum.oftemp, dehum.ofhumi) }}℃</el-col>
      <el-col :span="6" class="text">湿量</el-col>
      <el-col :span="17" :offset="1" class="value"
        >{{ calcHsl(dehum.oftemp, dehum.ofhumi) }}g/Kg</el-col
      >
      <el-col :span="6" class="text">焓值</el-col>
      <el-col :span="17" :offset="1" class="value"
        >{{ calcHanZhi(dehum.oftemp, dehum.ofhumi) }}Kj/Kg</el-col
      >
      <el-col :span="6" class="text">风量</el-col>
      <el-col :span="17" :offset="1" class="value"
        >--m³/h</el-col
      >
    </el-row>

    <!-- 六边形 -->
      <el-row style="font-size: 12px;color: #15d04c;position: absolute; top: 470px;width:auto;left:610px" > 环境评价雷达图 </el-row>
      <div v-if="gdhn">
        <el-row>
          <div
            style="
              position: absolute;
              width: 22.5rem;
              height: 25.5rem;
              background: url('../../static/images/qlg.png') no-repeat;
              background-size: 100%;
              top:470px;
              left:680px;
              color:#DEE2F0;
            "
          >
            <div
              style="
                position: absolute;
                top: 50%;
                margin-top: -5rem;
                left: 50%;
                margin-left: -2.5rem;
                width: 5rem;
                text-align: center;
                height: 10rem;
                line-height:1.8rem;
                color:#DEE2F0;
              "
            >
            <div :style="{'background-image':xfG4.mode==2?'url(\'../../static/images/icon/heat.png\')':'url(\'../../static/images/icon/cool.png\')'}" style="margin:0.5rem auto;margin-bottom:0.5rem;background:url('../../static/images/icon/cool.png') no-repeat;background-size:100% 100%;width:1.5rem;height:1.5rem"></div>
              <!-- <span style="margin-left:0.5rem;font-size: 2.5rem">{{qlg.sethumi||'--'}}</span> -->
              <span style="margin-left:0.5rem;font-size: 2.3rem">50</span>
              <span style="">%</span><br />
              <!-- <span style="margin-left:0.5rem;font-size: 2.5rem">{{qlgTemp||'--'}}</span> -->
                <span style="margin-left:0.5rem;font-size: 2.3rem">26</span>
              <span style="">℃</span><br>
              <div style="line-height:1rem" >{{getDpText(qlg,'mode')}}</div>
            </div>
            <div style="position: absolute;top:10.375rem; left:7.5625rem;background:url('../../static/images/icon/cs.png');background-size:100% 100%;width:0.7rem;height:0.7rem"></div>
              <div style="position: absolute;top:12.25rem; left:7.5625rem;background:url('../../static/images/icon/xf.png');background-size:100% 100%;width:0.7rem;height:0.7rem"></div>
              <div style="position: absolute;top:13.11875rem; left:7.5615rem;width:0.7rem;height:0.7rem;font-size:0.7rem;color:#B9B9B9">{{heatpump.settemp_hx}}℃</div>
              <div style="position: absolute;top:14.125rem; left:7.5625rem;background:url('../../static/images/icon/bl.png') no-repeat;background-size:100%;width:0.7rem;height:0.5rem"></div>
            <canvas id="qlg" style="width: 100%; height: 100%;"></canvas>
            <div
              style="
                position: absolute;
                transform: rotate(-30deg);
                top: 6.2rem;
                left: 6.5rem;
              "
            >
              {{ xfG4.snrco2 || '--' }}
            </div>
            <div
              style="
                font-size: 0.75rem;
                position: absolute;
                transform: rotate(-30deg);
                top: 7.1rem;
                left: 6.7rem;
              "
            >
              CO₂ ppm
            </div>

            <div
              style="
                position: absolute;
                transform: rotate(30deg);
                top: 5.8rem;
                left: 14.4rem;
              "
            >
              {{ xfG4['snrpm2.5'] || '--' }}
            </div>
            <div
              style="
                font-size: 0.75rem;
                position: absolute;
                transform: rotate(30deg);
                top: 7.5rem;
                left: 12.0rem;
              "
            >
              PM2.5 μg/m³
            </div>

            <div style="position: absolute; top: 12rem; left: 3.6rem;width:1.1rem;text-align:center">
              {{ gdhns.snrhumi || '--' }}
            </div>
            <div
              style="
                font-size: 0.75rem;
                position: absolute;
                position: absolute;
                top: 11rem;
                left: 5rem;
                word-break: break-all;
                width: 1.2rem;
              "
            >
              湿度 %
            </div>

            <div style="position: absolute; top: 12rem; left: 18rem;width:1.1rem;text-align:center">
              {{ xfG4.innertemp || 0 }}
            </div>
            <div
              style="
                font-size: 0.75rem;
                position: absolute;
                position: absolute;
                top: 11rem;
                left: 16.5rem;
                word-break: break-all;
                width: 1.2rem;
              "
            >
              室温 ℃
            </div>

            <div
              style="
                position: absolute;
                transform: rotate(30deg);
                top: 18.1rem;
                left: 6.8rem;
              "
            >
              {{xfG4['fveff']||'--'}}
            </div>
            <div
              style="
                font-size: 0.75rem;
                position: absolute;
                transform: rotate(30deg);
                top: 17.1rem;
                left: 6.5rem;
              "
            >
              新风效率 %
            </div>
            <div
              style="
                width: 1rem;
                height: 1rem;
                position: absolute;
                transform: rotate(30deg);
                top: 19.4rem;
                left: 6.2rem;
                background: url('../../static/images/icon/rs.png');
                background-size: 100% 100%;
              "
            ></div>

            <div
              style="
                position: absolute;
                transform: rotate(-30deg);
                top: 18.4rem;
                left: 14.1rem;
              "
            >
                {{ xfG4[`filterAused`] || 0 }}
            </div>
            <div
              style="
                font-size: 0.75rem;
                position: absolute;
                transform: rotate(-30deg);
                top: 16.9rem;
                left: 11.3rem;
              "
            >
              滤网已用天数
            </div>
            <div
              style="
                width: 1.2rem;
                height: 1.2rem;
                position: absolute;
                transform: rotate(-30deg);
                top: 19.5rem;
                left: 15.0rem;
                background: url('../../static/images/icon/lw.png');
                background-size: 100% 100% !important;
              "
            ></div>
          </div>
        </el-row>
      </div>
      <div v-else>
        <el-row>
          <div
            style="
              position: absolute;
              width: 22.5rem;
              height: 25.5rem;
              background: url('../../static/images/qlg.png') no-repeat;
              background-size: 100%;
              top:470px;
              left:680px;
              color:#DEE2F0;
            "
          >
            <div
              style="
                position: absolute;
                top: 50%;
                margin-top: -5rem;
                left: 50%;
                margin-left: -2.5rem;
                width: 5rem;
                text-align: center;
                height: 10rem;
                line-height:1.8rem;
                color:#DEE2F0;
              "
            >
            <div :style="{'background-image':qlg.mode==2?'url(\'../../static/images/icon/heat.png\')':'url(\'../../static/images/icon/cool.png\')'}" style="margin:0.5rem auto;margin-bottom:0.5rem;background:url('../../static/images/icon/cool.png') no-repeat;background-size:100% 100%;width:1.5rem;height:1.5rem"></div>
              <!-- <span style="margin-left:0.5rem;font-size: 2.5rem">{{qlg.sethumi||'--'}}</span> -->
              <span style="margin-left:0.5rem;font-size: 2.3rem">{{qlg.apphumi||'50'}}</span>
              <span style="">%</span><br />
              <!-- <span style="margin-left:0.5rem;font-size: 2.5rem">{{qlgTemp||'--'}}</span> -->
                <span style="margin-left:0.5rem;font-size: 2.3rem">{{qlg.apptemp||'26'}}</span>
              <span style="">℃</span><br>
              <div style="line-height:1rem" >{{getDpText(qlg,'mode')}}</div>
            </div>
            <div style="position: absolute;top:10.375rem; left:7.5625rem;background:url('../../static/images/icon/cs.png');background-size:100% 100%;width:0.7rem;height:0.7rem"></div>
              <div style="position: absolute;top:12.25rem; left:7.5625rem;background:url('../../static/images/icon/xf.png');background-size:100% 100%;width:0.7rem;height:0.7rem"></div>
              <div style="position: absolute;top:13.11875rem; left:7.5615rem;width:0.7rem;height:0.7rem;font-size:0.7rem;color:#B9B9B9">{{heatpump.settemp_hx}}℃</div>
              <div style="position: absolute;top:14.125rem; left:7.5625rem;background:url('../../static/images/icon/bl.png') no-repeat;background-size:100%;width:0.7rem;height:0.5rem"></div>
            <canvas id="qlg" style="width: 100%; height: 100%;"></canvas>
            <div
              style="
            
              text-align: center;
                position: absolute;
                transform: rotate(-30deg);
                top: 5.9rem;
                left: 4.2rem;
                width: 7.2rem;
              "
            >
              {{ zs.value }}
            </div>
            <div
              style="
              
                font-size: 0.75rem;
                text-align: center;
                position: absolute;
                transform: rotate(-30deg);
                top: 7rem;
                left: 5.4rem;
                width: 6rem
              "
            >
              {{zs.text}}
            </div>

            <div
              style="
              
               text-align: center;
                position: absolute;
                transform: rotate(30deg);
                top: 5.9rem;
                left: 11.4rem;
                width: 7.2rem;
              "
            >
            {{ ys.value  }}
            </div>
            <div
              style="
              
               text-align: center;
                font-size: 0.75rem;
                position: absolute;
                transform: rotate(30deg);
                top: 7rem;
                left: 11.3rem;
                width: 6rem
              "
            >
            {{ys.text}}
            </div>

            <div style="position: absolute; top: 12rem; left: 3.6rem;width:1.1rem;text-align:center">
              {{ qlg.snrhumi }}
            </div>
            <div
              style="
                font-size: 0.75rem;
                position: absolute;
                position: absolute;
                top: 11rem;
                left: 5rem;
                word-break: break-all;
                width: 1.2rem;
              "
            >
              湿度 %
            </div>

            <div style="position: absolute; top: 12rem; left: 18rem;width:1.1rem;text-align:center">
              {{ qlg.snrtemp  }}
            </div>
            <div
              style="
                font-size: 0.75rem;
                position: absolute;
                position: absolute;
                top: 11rem;
                left: 16.5rem;
                word-break: break-all;
                width: 1.2rem;
              "
            >
              室温 ℃
            </div>

            <div
              style="
            
               text-align: center;
                position: absolute;
                transform: rotate(30deg);
                top: 18.4rem;
                left: 4.4rem;
                width: 7.2rem;
              "
            >
            {{ zx.value  }}
            </div>
            <div
              style="
             
                font-size: 0.75rem;
                text-align: center;
                position: absolute;
                transform: rotate(30deg);
                top: 17rem;
                left: 5.4rem;
                width: 6rem
              "
            >
            {{zx.text}}
            </div>
            <div
              style="
                width: 1rem;
                height: 1rem;
                position: absolute;
                transform: rotate(30deg);
                top: 19.8rem;
                left: 6.7rem;
                background: url('../../static/images/icon/rs.png');
                background-size: 100% 100%;
              "
            ></div>

            <div
              style="
              text-align: center;
                position: absolute;
                transform: rotate(-30deg);
                top: 18.4rem;
                left: 11.4rem;
                width: 7.2rem;
              "
            >
            {{ yx.value  }}
            </div>
            <div
              style="
             
                font-size: 0.75rem;
                position: absolute;
                text-align: center;
                transform: rotate(-30deg);
                top: 17rem;
                left: 11.3rem;
                width: 6rem
              "
            >
            {{yx.text}}
            </div>
            <div
              style="
                width: 1.2rem;
                height: 1.2rem;
                position: absolute;
                transform: rotate(-30deg);
                top: 19.5rem;
                left: 15.0rem;
                background: url('../../static/images/icon/lw.png');
                background-size: 100% 100% !important;
              "
            ></div>
          </div>
        </el-row>
      </div>

      <!-- PTC -->
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 278px;
        left: 675px;
        width: 38px;
        height: 60px;
        text-align: center;
      "
    >
      <el-col :span="24"  class="value">{{ dehum.ptctemp ||'--' }}℃</el-col>
        <el-col v-if="false" :span="24" class="text">湿度</el-col>
      <el-col v-if="false" :span="24" class="value">--%</el-col>
      <el-col v-if="false" :span="24" class="text">湿量</el-col>
      <el-col v-if="false" :span="24"  class="value"
        >--g/Kg</el-col
      >
    </el-row>
    <el-row
      style="
        font-size: 12px;
        position: absolute;
        top: 204px;
        left: 680px;
        width: 38px;
        height: 30px;
        text-align: center;
      "
    >
      <el-col :span="24"  class="value">{{ dehum.snrtemp ||xfG4.innertemp||'--' }}℃</el-col>
    </el-row>
    <el-dialog
      title="故障历史 (最近100条)"
      :visible.sync="dialogTableVisible"
      width="400px"
    >
      <el-table
        :data="gridData"
        stripe
        border
        height="250"
        :header-cell-style="{ padding: '2px' }"
        :cell-style="{ padding: '5px' }"
      >
        <el-table-column property="createdtime" label="日期"></el-table-column>
        <el-table-column property="errmsg" label="故障内容"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
  <div v-else
    style="
      width: 100%;
      height: auto;
      padding-top: 2rem;
      padding-bottom: 2rem;
      box-sizing: border-box;
      overflow-x: hidden;
    "
  >
    <el-alert
      v-if="!mibeeOnline"
      :title="errortext"
      type="error"
      :closable="false"
      effect="dark"
      show-icon
    >
    </el-alert>
    <div style="width: 90%; margin: 0 auto; background: #000;border-radius: 1.53rem; padding-bottom: 2rem;box-sizing: border-box;">
      <div
        style="
          color: #ffffff;
          font-size: 1.23rem;
          background: #5e5f66;
          height: 1.9rem;
          padding-top: 0.4rem;
          border-top-left-radius: 1.2rem;
          border-top-right-radius: 1.2rem;
        "
      >
        室内环境
      </div>
          <!-- <div style="width:1667px;height:880px; background: url('../../static/images/icon/stopfanset.png'); background-size: 100% 100%;"></div> -->
      <el-row
        style="
          font-size: 12px;
          width: 96%;
          margin: 0 auto;
          height: auto;
          text-align: left;
          overflow: hidden;
          overflow-y: auto;
        "
      >
        <el-col
          :span="24"
          style="
            background: #141517;
            border-radius: 1.54rem;
            height: 10.76rem;
            margin-top: 0.77rem;
          "
          v-for="item in devicelist.filter((x) => {
            return (
              x.protocolid == 228
            );
          })"
          :key="item.innerid"
        >
          <el-row>
            <el-col :span="11">
              <div
                style="
                  color: #ffffff;
                  font-size: 1rem;
                  height: 3.15rem;
                  width: 100%;
                  line-height: 3.15rem;
                  padding-left: 2.3rem;
                "
              >
                {{ item.roomname }}
              </div>
            </el-col>
            <el-col :span="3">
              <div
                style="
                  color: #15d04c;
                  font-size: 12px;
                  height:3.15rem;
                  line-height:3.15rem;
                "
                v-if="item.devtype == 2"
              >
                风盘
              </div>
            </el-col>
            <el-col :span="3">
              <div
                class="value"
                style="
                  font-size: 12px;
                  height:3.15rem;
                  line-height:3.15rem;
                  text-align: center;
                "
                v-if="item.devtype == 2"
              >
                {{ item.ecfanrun?(item.ecfanrun+'%'):'停止1' }}
              </div>
            </el-col>
            <el-col :span="4">
              <div
                style="
                  color: #15d04c;
                  font-size: 12px;
                  height:3.15rem;
                  line-height:3.15rem;
                "
              >
                控制器
              </div>
            </el-col>
            <el-col :span="3">
              <div
                class="value"
                v-if="!item.online"
                style="
                  font-size: 12px;
                  color: red;
                  width: 3.08rem;
                  text-align: center;
                  height:3.15rem;
                  line-height:3.15rem;
                "
              >
                离线
              </div>
              <div
                v-else
                class="value"
                style="
                  font-size: 12px;
                  width: 3.08rem;
                  text-align: center;
                  height:3.15rem;
                  line-height:3.15rem;
                "
              >
                {{ getDpText(item, "power") }}
              </div>
            </el-col>
          </el-row>
          <div
            style="
              background: #000002;
              width: 90%;
              height: 6.32rem;
              margin-left: 5%;
              padding-top: 3%;
              border-radius: 1.53rem;
              box-sizing: border-box;
            "
          >
            <el-row
              style="
                display: inline-block;
                width: 50%;
                padding-left: 3%;
                height: 6.15rem;
                text-align: left;
              "
            >
              <el-col :span="11" class="text_big">设定温度</el-col>
              <el-col :span="9" :offset="1" class="value_big"
                >{{ item.settemp.toFixed(1) }}℃</el-col
              >
              <el-col :span="11" class="text_big">室内温度</el-col>
              <el-col :span="9" :offset="1" class="value_big"
                >{{ item.temp.toFixed(1) }}℃</el-col
              >
              <el-col :span="11" class="text_big">露点温度</el-col>
              <el-col :span="9" :offset="1" class="value_big"
                >{{ item.dewtemp.toFixed(1) }}℃</el-col
              >
            </el-row>
            <el-row
              style="
                display: inline-block;
                width: 45%;
                padding-left: 3%;
                height: 6.15rem;
                text-align: left;
              "
            >
              <el-col :span="9" class="text_big">湿度</el-col>
              <el-col :span="11" :offset="1" class="value_big"
                >{{ item.snrhumi }}%</el-col
              >
              <el-col :span="9" class="text_big">湿量</el-col>
              <el-col :span="11" :offset="1" class="value_big">
                {{ calcHsl(item.temp, item.snrhumi).toFixed(0) }}g/Kg</el-col
              >
              <!-- <el-col :span="11" :offset="1" class="value_big">
                444445555555g/Kg</el-col
              > -->
              <el-col :span="9" class="text_big">焓值</el-col>
              <el-col :span="11" :offset="1" class="value_big"
                >{{ calcHanZhi(item.temp, item.snrhumi) }}Kj/Kg</el-col
              >
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 室外进风口 -->
    <div v-if="!(project.aiodp&&project.aiodp.indexOf('in')>=0)"
         style="background: #000; width: 90%; height: 6.32rem; margin-left: 5%; padding-top: 3%; border-radius: 1.53rem; margin-top: 2rem; box-sizing: border-box;"
    >
      <div
        style="
          color: #15d04c;
          font-size: 12px;
          margin-bottom: 0.5rem;
          text-align: left;
          margin-left: 1rem
        "
      >
      </div>
      <el-row
        style="
          display: inline-block;
          width: 47%;
          padding-left: 3%;
          height: 4.15rem;
          text-align: left;
        "
      >
        <el-col :span="9" class="text_big">温度</el-col>
        <el-col :span="11" :offset="1" class="value_big"
          >{{ dehum.retemp4 }}℃</el-col
        >
        <el-col :span="9" class="text_big">湿量</el-col>
        <el-col :span="11" :offset="1" class="value_big"
          >{{ calcHsl(dehum.retemp4, dehum.rehumi4) }}g/Kg</el-col
        >
      </el-row>
      <el-row
        style="
          display: inline-block;
          width: 48%;
          padding-left: 3%;
          height: 4.15rem;
          text-align: left;
        "
      >
        <el-col :span="9" class="text_big">湿度</el-col>
        <el-col :span="11" :offset="1" class="value_big"
          >{{ dehum.rehumi4 }}%</el-col
        >
        <el-col :span="9" class="text_big">焓值</el-col>
        <el-col :span="11" :offset="1" class="value_big"
          >{{ calcHanZhi(dehum.retemp4, dehum.rehumi4) }}Kj/Kg</el-col
        >
      </el-row>
    </div>
    <div v-else style="background: #000; width: 90%; height: 6.32rem; margin-left: 5%; padding-top: 3%; border-radius: 1.53rem; margin-top: 2rem; box-sizing: border-box;">
      <div
        style="
          color: #15d04c;
          font-size: 12px;
          margin-bottom: 0.5rem;
        "
      >
        室外进风
      </div>
      <el-row
        style="
          display: inline-block;
          width: 100%;
          height: 4.15rem;
          text-align: center;
        "
      >
      未添加相关传感器
      </el-row>
    </div>
    <div style="
      width: 90%;
      height: 55rem;
      margin: 0 auto;
      background: #000;
      border-radius: 1.53rem;
      padding-top: 0.4rem;
      padding-bottom: 2rem;
      margin-top: 2rem;
      box-sizing: border-box;
      background-image: url('../../static/images/bgyd.png');
      background-size: 105% 85%;
      background-repeat: no-repeat;
      position: relative;">
      <div
        style="
          color: #ffffff;
          font-size: 1.23rem;
          box-sizing: border-box;
        "
      >
        数字暖通AIO系统空调
        <span v-if="!qlg.online" style="color: red; font-size: 12px">离线</span>
      </div>
      <img src="/../../static/images/icon/run1.gif"
      v-if="mibeeOnline &&dehum&&dehum.power"
      style="
        width:23rem;
        height: 12.31rem;
        z-index: 1;
        position: absolute;
        top: 6.15rem;
        left: 0.7rem"/>
      <div
        v-if="!!!dehum.outfanspd || !mibeeOnline || !!!dehum.power"
        style="
          z-index: 1;
          position: absolute;
          width: 1.77rem;
          height: 1.77rem;
          top: 8.69rem;
          left: 11.54rem;
          background: url('../../static/images/icon/stopfanset.png');
          background-size: 100% 100%;
        "
      ></div>
      <div
        v-else
        style="
          z-index: 1;
          position: absolute;
          width: 1.77rem;
          height: 1.77rem;
          top: 8.69rem;
          left: 11.54rem;
          background: url('../../static/images/icon/runfanset.gif');
          background-size: 100% 100% !important;
        "
      ></div>
      <div
        v-if="!!!dehum.infanspd || !mibeeOnline || !!!dehum.power"
        style="
          z-index: 1;
          position: absolute;
          width: 1.77rem;
          height: 1.77rem;
          top: 8.69rem;
          left: 18.92rem;
          background: url('../../static/images/icon/stopfanset.png');
          background-size: 100% 100%;
        "
      ></div>
      <div
        v-else
        style="
          z-index: 1;
          position: absolute;
          width: 1.77rem;
          height: 1.77rem;
          top: 8.69rem;
          left: 18.92rem;
          background: url('../../static/images/icon/runfanset.gif');
          background-size: 100% 100% !important;
        "
      ></div>
      <!-- 室内回风口 -->
      <div v-if="gdhn">
        <el-row v-show="!(project.aiodp&&project.aiodp.indexOf('roomout')>=0)"
          style="
            font-size: 12px;
            position: absolute;
            top: 2.62rem;
            left: 4.62rem;
            width: 6.92rem;
            height: 4.62rem;
            text-align: left;
          "
        >
          <el-col :span="11" class="text">温度</el-col>
          <el-col :span="10" :offset="1" class="value">{{ xfG4.innertemp }}℃</el-col>
          <el-col :span="11" class="text">湿度</el-col>
          <el-col :span="10" :offset="1" class="value">{{ xfG4.innerhumid }}%</el-col>
        </el-row>
        <el-row
          v-show="!(project.aiodp&&project.aiodp.indexOf('roomout')>=0)"
          style="
            font-size: 12px;
            position: absolute;
            top: 2.62rem;
            left: 13.07rem;
            width: 7.69rem;
            height: 4.62rem;
            text-align: left;
          "
        >
          <el-col :span="11" class="text">CO₂</el-col>
          <el-col :span="10" :offset="1" class="value">{{ xfG4.snrco2||'--' }}ppm</el-col>
          <el-col :span="11" class="text">PM2.5</el-col>
          <el-col :span="10" :offset="1" class="value"
            >{{ xfG4["snrpm2.5"]||'--' }}ug/m³</el-col
          >
        </el-row>
      </div>
      <div v-else>
        <el-row v-show="!(project.aiodp&&project.aiodp.indexOf('roomout')>=0)"
          style="
            font-size: 12px;
            position: absolute;
            top: 2.62rem;
            left: 4.62rem;
            width: 6.92rem;
            height: 4.62rem;
            text-align: left;
          "
        >
          <el-col :span="11" class="text">温度</el-col>
          <el-col :span="10" :offset="1" class="value">{{ dehum.snrtemp }}℃</el-col>
          <el-col :span="11" class="text">湿度</el-col>
          <el-col :span="10" :offset="1" class="value">{{ dehum.snrhumi }}%</el-col>
          <el-col :span="11" class="text">湿量</el-col>
          <el-col :span="10" :offset="1" class="value"
            >{{ calcHsl(dehum.snrtemp, dehum.snrhumi) }}g/Kg</el-col
          >
        </el-row>
        <el-row
          v-show="!(project.aiodp&&project.aiodp.indexOf('roomout')>=0)"
          style="
            font-size: 12px;
            position: absolute;
            top: 2.62rem;
            left: 13.07rem;
            width: 7.69rem;
            height: 4.62rem;
            text-align: left;
          "
        >
          <el-col :span="11" class="text">焓值</el-col>
          <el-col :span="10" :offset="1" class="value"
            >{{ calcHanZhi(dehum.snrtemp, dehum.snrhumi) }}Kj/Kg</el-col
          >
          <el-col :span="11" class="text">CO₂</el-col>
          <el-col :span="10" :offset="1" class="value">{{ dehum.snrco2||'--' }}ppm</el-col>
          <el-col :span="11" class="text">PM2.5</el-col>
          <el-col :span="10" :offset="1" class="value"
            >{{ dehum["snrpm2.5"]||'--' }}ug/m³</el-col
          >
        </el-row>
      </div>
      <!-- 室内新风口 -->
      <el-row v-show="!(project.aiodp&&project.aiodp.indexOf('roomin')>=0)"
        style="
          font-size: 12px;
          position: absolute;
          top: 19.3rem;
          left: 4rem;
          width: 4.46rem;
          height: 4.62rem;
          text-align: left;
        "
      >
        <el-col :span="11" class="text">风温</el-col>
        <el-col :span="10" :offset="1" class="value">{{ dehum.oftemp }}℃</el-col>
          <el-col :span="11" class="text">露点</el-col>
        <el-col :span="10" :offset="1" class="value">{{ calcLuDian(dehum.oftemp, dehum.ofhumi) }}℃</el-col>
        <el-col :span="11" class="text">湿量</el-col>
        <el-col :span="10" :offset="1" class="value"
          >{{ calcHsl(dehum.oftemp, dehum.ofhumi) }}g/Kg</el-col
        >
        <el-col :span="11" class="text">焓值</el-col>
        <el-col :span="10" :offset="1" class="value"
          >{{ calcHanZhi(dehum.oftemp, dehum.ofhumi) }}Kj/Kg</el-col
        >
        <el-col v-if="false" :span="11" class="text">风量</el-col>
        <el-col v-if="false" :span="10" :offset="1" class="value"
          >--m³/h</el-col
        >
      </el-row>
      <!-- PTC状态 -->
      <el-row
        v-if="true"
        style="
          font-size: 12px;
          position: absolute;
          top: 19.3rem;
          left: 11rem;
          width: 6rem;
          height: 4.62rem;
          text-align: left;
        "
      >
        <el-col :span="16" class="text_big">PTC调温</el-col>
        <el-col :span="8" class="value_big"
          >{{ getDpText(dehum,'ptcsta') }}</el-col
        >
        <!-- 进风温度-氟盘前温度/进风温度-回风温度 -->
        <el-col :span="16" class="text_big">除湿盘管</el-col>
        <el-col :span="8" class="value_big"
          >{{ getDpText(dehum,'spjksta') }}</el-col>
      </el-row>
      <!-- 全热交换 -->
      <el-row
      v-if="!(project.aiodp&&(project.aiodp.indexOf('roomout')>=0||project.aiodp.indexOf('in')>=0||project.aiodp.indexOf('out')>=0))"
        style="
          font-size: 12px;
          position: absolute;
          top: 19.3rem;
          left: 17.69rem;
          width: 6.46rem;
          height: 4.62rem;
          text-align: left;
        "
      >
        <el-col :span="15" class="text_big">温度效率</el-col>
        <el-col :span="6" :offset="1" class="value_big"
          >≥{{ calcRate(dehum.retemp4, dehum.intemp, dehum.snrtemp) }}%</el-col
        >
        <!-- 进风温度-氟盘前温度/进风温度-回风温度 -->
        <el-col :span="15" class="text_big">湿度效率</el-col>
        <el-col :span="6" :offset="1" class="value_big"
          >≥{{
            calcRate(
              calcHsl(dehum.retemp4, dehum.rehumi4),
              calcHsl(dehum.intemp, dehum.inhumi),
              calcHsl(dehum.snrtemp, dehum.snrhumi)
            )
          }}%</el-col
        >
        <el-col :span="15" class="text_big">全热效率</el-col>
        <el-col :span="6" :offset="1" class="value_big"
          >≥{{
            calcRate(
              calcHanZhi(dehum.retemp4, dehum.rehumi4),
              calcHanZhi(dehum.intemp, dehum.inhumi),
              calcHanZhi(dehum.snrtemp, dehum.snrhumi)
            )
          }}%</el-col
        >
      </el-row>
      <el-row
        v-else
        style="
          font-size: 12px;
          position: absolute;
          top: 19.3rem;
          left: 17.69rem;
          width: 6.46rem;
          height: 4.62rem;
          text-align: left;
        "
      >
        <el-col :span="15" class="text_big">温度效率</el-col>
        <el-col :span="6" :offset="1" class="value_big"
          >≥85%</el-col>
        <!-- 进风温度-氟盘前温度/进风温度-回风温度 -->
        <el-col :span="15" class="text_big">湿度效率</el-col>
        <el-col :span="6" :offset="1" class="value_big"
          >≥85%</el-col>
        <el-col :span="15" class="text_big">全热效率</el-col>
        <el-col :span="6" :offset="1" class="value_big"
          >≥85%</el-col>
      </el-row>
      <!-- 出风风机 -->
      <el-row
        style="
          font-size: 12px;
          position: absolute;
          top: 10.7rem;
          left: 11.4rem;
          width: 7.69rem;
          height: 4.62rem;
          text-align: left;
        "
      >
        <el-col :span="24" class="text">转速</el-col>
        <el-col :span="24" class="value">{{ dehum.outfanspd||0 }}rpm</el-col>
      </el-row>
      <el-row
        style="
          font-size: 12px;
          position: absolute;
          top: 13.1rem;
          left: 11.4rem;
          width: 7.69rem;
          height: 4.62rem;
          text-align: left;
        "
      >
        <el-col :span="24" class="text">风速</el-col>
        <el-col :span="24" class="value">{{ getDpText(dehum,'outfanrun') }}</el-col>
      </el-row>
      <!-- 进风风机 -->
      <el-row
        style="
          font-size: 12px;
          position: absolute;
          top: 10.7rem;
          left: 17.4rem;
          width: 7.69rem;
          height: 4.62rem;
          text-align: left;
        "
      >
        <el-col :span="24" class="text">转速</el-col>
        <el-col :span="24"  class="value">{{ dehum.infanspd||0 }}rpm</el-col>
      </el-row>
      <el-row
        style="
          font-size: 12px;
          position: absolute;
          top: 13.1rem;
          left: 17.4rem;
          width: 7.69rem;
          height: 4.62rem;
          text-align: left;
        "
      >
        <el-col :span="24" class="text">风速</el-col>
        <el-col :span="24"  class="value">{{getDpText(dehum,'infanrun') }}</el-col>
      </el-row>
      <!-- PTC -->
      <el-row
        style="
          font-size: 12px;
          position: absolute;
          top: 11.8rem;
          left: 5.23rem;
          width: 8.46rem;
          height: 4.62rem;
          text-align: left;
        "
      >
        <el-col :span="24" class="text">温度</el-col>
        <el-col :span="24"  class="value">{{ dehum.ptctemp }}℃</el-col>
          <el-col v-if="false" :span="24" class="text">湿度</el-col>
        <el-col v-if="false" :span="24" class="value">--%</el-col>
        <el-col v-if="false" :span="24" class="text">湿量</el-col>
        <el-col v-if="false" :span="24"  class="value"
          >--g/Kg</el-col
        >
      </el-row>
      <!-- 六边形 -->
      <el-row style="font-size: 12px;color: #15d04c;position: absolute;
    top: 26rem;width:auto;left:1rem" > 环境评价雷达图 </el-row>
      <el-row v-if="gdhn"
        style="
          width: 22.5rem;
          height: 25.5rem;
          margin: 26rem auto;
      ">
        <div
          style="
            position: absolute;
            width: 22.5rem;
            height: 25.5rem;
            background: url('../../static/images/qlg.png') no-repeat;
            background-size: 100%;
            color:#DEE2F0;
          "
        >
          <div
            style="
              position: absolute;
              top: 50%;
              margin-top: -5rem;
              left: 50%;
              margin-left: -2.2rem;
              width: 4.4rem;
              text-align: center;
              height: 10rem;
              line-height:1.8rem;
              color:#DEE2F0;
            "
          >
          <div :style="{'background-image':xfG4.mode==2?'url(\'../../static/images/icon/heat.png\')':'url(\'../../static/images/icon/cool.png\')'}" style="margin:0.5rem auto;margin-bottom:0.5rem;background:url('../../static/images/icon/cool.png') no-repeat;background-size:100% 100%;width:1.5rem;height:1.5rem"></div>
            <span style="margin-left:0.5rem;font-size: 2.5rem">{{xfG4.innerhumid||'--'}}</span
            ><span style="">%</span><br />
            <span style="margin-left:0.5rem;font-size: 2.5rem">{{qlgTemp||'--'}}</span
            ><span style="">℃</span><br>
            <div style="line-height:1rem" >{{getDpText(xfG4,'mode')}}</div>
          </div>
          <div style="position: absolute;top:10.375rem; left:7.5625rem;background:url('../../static/images/icon/cs.png');background-size:100% 100%;width:0.7rem;height:0.7rem"></div>
            <div style="position: absolute;top:12.25rem; left:7.5625rem;background:url('../../static/images/icon/xf.png');background-size:100% 100%;width:0.7rem;height:0.7rem"></div>
            <div style="position: absolute;top:13.11875rem; left:7.5615rem;width:0.7rem;height:0.7rem;font-size:0.7rem;color:#B9B9B9">{{heatpump.settemp_hx}}℃</div>
            <div style="position: absolute;top:14.125rem; left:7.5625rem;background:url('../../static/images/icon/bl.png') no-repeat;background-size:100%;width:0.7rem;height:0.5rem"></div>
          <canvas id="qlg" style="width: 100%; height: 100%;"></canvas>
          <div
            style="
              position: absolute;
              transform: rotate(-30deg);
              top: 6.2rem;
              left: 6.5rem;
            "
          >
            {{ xfG4.snrco2 || '--' }}
          </div>
          <div
            style="
              font-size: 0.75rem;
              position: absolute;
              transform: rotate(-30deg);
              top: 7.1rem;
              left: 6.7rem;
            "
          >
            CO₂ ppm
          </div>

          <div
            style="
              position: absolute;
              transform: rotate(30deg);
              top: 5.8rem;
              left: 14.4rem;
            "
          >
            {{ xfG4['snrpm2.5'] || '--' }}
          </div>
          <div
            style="
              font-size: 0.75rem;
              position: absolute;
              transform: rotate(30deg);
              top: 7.5rem;
              left: 12.0rem;
            "
          >
            PM2.5 μg/m³
          </div>

          <div style="position: absolute; top: 12rem; left: 3.6rem;width:1.1rem;text-align:center">
            {{ gdhns.snrhumi || '--' }}
          </div>
          <div
            style="
              font-size: 0.75rem;
              position: absolute;
              position: absolute;
              top: 11rem;
              left: 5rem;
              word-break: break-all;
              width: 1.2rem;
            "
          >
            湿度 %
          </div>

          <div style="position: absolute; top: 12rem; left: 18rem;width:1.1rem;text-align:center">
            {{ xfG4.innertemp || 0 }}
          </div>
          <div
            style="
              font-size: 0.75rem;
              position: absolute;
              position: absolute;
              top: 11rem;
              left: 16.5rem;
              word-break: break-all;
              width: 1.2rem;
            "
          >
            室温 ℃
          </div>

          <div
            style="
              position: absolute;
              transform: rotate(30deg);
              top: 18.1rem;
              left: 6.8rem;
            "
          >
            {{xfG4['fveff']||'--'}}
          </div>
          <div
            style="
              font-size: 0.75rem;
              position: absolute;
              transform: rotate(30deg);
              top: 17.1rem;
              left: 6.5rem;
            "
          >
            新风效率 %
          </div>
          <div
            style="
              width: 1rem;
              height: 1rem;
              position: absolute;
              transform: rotate(30deg);
              top: 19.4rem;
              left: 6.2rem;
              background: url('../../static/images/icon/rs.png');
              background-size: 100% 100%;
            "
          ></div>

          <div
            style="
              position: absolute;
              transform: rotate(-30deg);
              top: 18.4rem;
              left: 14.1rem;
            "
          >
              {{ xfG4[`filterAused`] || 0 }}
          </div>
          <div
            style="
              font-size: 0.75rem;
              position: absolute;
              transform: rotate(-30deg);
              top: 16.9rem;
              left: 11.3rem;
            "
          >
            滤网已用天数
          </div>
          <div
            style="
              width: 1.2rem;
              height: 1.2rem;
              position: absolute;
              transform: rotate(-30deg);
              top: 19.5rem;
              left: 15.0rem;
              background: url('../../static/images/icon/lw.png');
              background-size: 100% 100% !important;
            "
          ></div>
        </div>
      </el-row>
      <el-row v-else
        style="
          width: 22.5rem;
          height: 25.5rem;
          margin: 26rem auto;
      ">
        <div
            style="
            
              width: 22.5rem;
              height: 25.5rem;
              background: url('../../static/images/qlg.png') no-repeat;
              background-size: 100%;
              top:470px;
              left:680px;
              color:#DEE2F0;
            "
          >
            <div
              style="
                position: absolute;
                top: 50%;
                margin-top: -5rem;
                left: 50%;
                margin-left: -2.5rem;
                width: 5rem;
                text-align: center;
                height: 10rem;
                line-height:1.8rem;
                color:#DEE2F0;
              "
            >
            <div :style="{'background-image':qlg.mode==2?'url(\'../../static/images/icon/heat.png\')':'url(\'../../static/images/icon/cool.png\')'}" style="margin:0.5rem auto;margin-bottom:0.5rem;background:url('../../static/images/icon/cool.png') no-repeat;background-size:100% 100%;width:1.5rem;height:1.5rem"></div>
              <!-- <span style="margin-left:0.5rem;font-size: 2.5rem">{{qlg.sethumi||'--'}}</span> -->
              <span style="margin-left:0.5rem;font-size: 2.3rem">{{qlg.apphumi||'50'}}</span>
              <span style="">%</span><br />
              <!-- <span style="margin-left:0.5rem;font-size: 2.5rem">{{qlgTemp||'--'}}</span> -->
                <span style="margin-left:0.5rem;font-size: 2.3rem">{{qlg.apptemp||'26'}}</span>
              <span style="">℃</span><br>
              <div style="line-height:1rem" >{{getDpText(qlg,'mode')}}</div>
            </div>
            <div style="position: absolute;top:10.375rem; left:7.5625rem;background:url('../../static/images/icon/cs.png');background-size:100% 100%;width:0.7rem;height:0.7rem"></div>
              <div style="position: absolute;top:12.25rem; left:7.5625rem;background:url('../../static/images/icon/xf.png');background-size:100% 100%;width:0.7rem;height:0.7rem"></div>
              <div style="position: absolute;top:13.11875rem; left:7.5615rem;width:0.7rem;height:0.7rem;font-size:0.7rem;color:#B9B9B9">{{heatpump.settemp_hx}}℃</div>
              <div style="position: absolute;top:14.125rem; left:7.5625rem;background:url('../../static/images/icon/bl.png') no-repeat;background-size:100%;width:0.7rem;height:0.5rem"></div>
            <canvas id="qlg" style="width: 100%; height: 100%;"></canvas>
            <div
              style="
            
              text-align: center;
                position: absolute;
                transform: rotate(-30deg);
                top: 5.9rem;
                left: 4.2rem;
                width: 7.2rem;
              "
            >
              {{ zs.value  }}
            </div>
            <div
              style="
              
                font-size: 0.75rem;
                text-align: center;
                position: absolute;
                transform: rotate(-30deg);
                top: 7rem;
                left: 5.4rem;
                width: 6rem
              "
            >
              {{zs.text}}
            </div>

            <div
              style="
              
               text-align: center;
                position: absolute;
                transform: rotate(30deg);
                top: 5.9rem;
                left: 11.4rem;
                width: 7.2rem;
              "
            >
            {{ ys.value  }}
            </div>
            <div
              style="
              
               text-align: center;
                font-size: 0.75rem;
                position: absolute;
                transform: rotate(30deg);
                top: 7rem;
                left: 11.4rem;
                width: 6rem
              "
            >
            {{ys.text}}
            </div>

            <div style="position: absolute; top: 12rem; left: 3.6rem;width:1.1rem;text-align:center">
              {{ qlg.snrhumi  }}
            </div>
            <div
              style="
                font-size: 0.75rem;
                position: absolute;
                position: absolute;
                top: 11rem;
                left: 5rem;
                word-break: break-all;
                width: 1.2rem;
              "
            >
              湿度 %
            </div>

            <div style="position: absolute; top: 12rem; left: 18rem;width:1.1rem;text-align:center">
              {{ qlg.snrtemp  }}
            </div>
            <div
              style="
                font-size: 0.75rem;
                position: absolute;
                position: absolute;
                top: 11rem;
                left: 16.5rem;
                word-break: break-all;
                width: 1.2rem;
              "
            >
              室温 ℃
            </div>

            <div
              style="
            
               text-align: center;
                position: absolute;
                transform: rotate(30deg);
                top: 18.4rem;
                left: 4.4rem;
                width: 7.2rem;
              "
            >
            {{ zx.value}}
            </div>
            <div
              style="
             
                font-size: 0.75rem;
                text-align: center;
                position: absolute;
                transform: rotate(30deg);
                top: 17rem;
                left: 5.4rem;
                width: 6rem
              "
            >
            {{zx.text}}
            </div>
            <div
              style="
                width: 1rem;
                height: 1rem;
                position: absolute;
                transform: rotate(30deg);
                top: 19.8rem;
                left: 6.7rem;
                background: url('../../static/images/icon/rs.png');
                background-size: 100% 100%;
              "
            ></div>

            <div
              style="
              text-align: center;
                position: absolute;
                transform: rotate(-30deg);
                top: 18.4rem;
                left: 11.3rem;
                width: 7.2rem;
              "
            >
            {{ yx.value }}
            </div>
            <div
              style="
             
                font-size: 0.75rem;
                position: absolute;
                text-align: center;
                transform: rotate(-30deg);
                top: 17rem;
                left: 11.3rem;
                width: 6rem
              "
            >
            {{yx.text}}
            </div>
            <div
              style="
                width: 1.2rem;
                height: 1.2rem;
                position: absolute;
                transform: rotate(-30deg);
                top: 19.5rem;
                left: 15.0rem;
                background: url('../../static/images/icon/lw.png');
                background-size: 100% 100% !important;
              "
            ></div>
          </div>
      </el-row>
    </div>
        <!-- 室外排风口 -->
    <div v-if="!(project.aiodp&&project.aiodp.indexOf('out')>=0)"
         style="background: #000; width: 90%; height: 6.32rem; margin-left: 5%; padding-top: 3%; border-radius: 1.53rem; margin-top: 2rem; box-sizing: border-box;"
    >
      <div
        style="
          color: #15d04c;
          font-size: 12px;
          margin-bottom: 0.5rem;
          text-align: left;
          margin-left: 1rem
        "
      >
        室外排风
      </div>
      <el-row
        style="
          display: inline-block;
          width: 47%;
          padding-left: 3%;
          height: 4.15rem;
          text-align: left;
        "
      >
        <el-col :span="9" class="text_big">温度</el-col>
        <el-col :span="11" :offset="1" class="value_big"
          >{{ dehum.retemp5 }}℃</el-col
        >
        <el-col :span="9" class="text_big">湿量</el-col>
        <el-col :span="11" :offset="1" class="value_big"
          >{{ calcHsl(dehum.retemp5, dehum.rehumi5) }}g/Kg</el-col
        >
      </el-row>
      <el-row
        style="
          display: inline-block;
          width: 48%;
          padding-left: 3%;
          height: 4.15rem;
          text-align: left;
        "
      >
        <el-col :span="9" class="text_big">湿度</el-col>
        <el-col :span="11" :offset="1" class="value_big"
          >{{ dehum.rehumi5 }}%</el-col
        >
        <el-col :span="9" class="text_big">焓值</el-col>
        <el-col :span="11" :offset="1" class="value_big"
          >{{ calcHanZhi(dehum.retemp5, dehum.rehumi5) }}Kj/Kg</el-col
        >
      </el-row>
    </div>
    <div v-else style="background: #000; width: 90%; height: 6.32rem; margin-left: 5%; padding-top: 3%; border-radius: 1.53rem; margin-top: 2rem; box-sizing: border-box;">
      <div
        style="
          color: #15d04c;
          font-size: 12px;
          margin-bottom: 0.5rem;
          text-align: left;
          margin-left: 1rem
        "
      >
        室外排风
      </div>
      <el-row
        style="
          display: inline-block;
          width: 100%;
          height: 4.15rem;
          text-align: center;
        "
      >
      未添加相关传感器
      </el-row>
    </div>
    <!-- 气象站 -->
    <div style="background: #000; width: 90%; height: 8rem; margin-left: 5%; padding-top: 3%; border-radius: 1.53rem; margin-top: 2rem; box-sizing: border-box;
      "
    >
      <div
        style="
          color: #15d04c;
          font-size: 12px;
          margin-bottom: 0.5rem;
          text-align: left;
          margin-left: 1rem
        "
      >
        气象站
      </div>
      <el-row
        style="
          display: inline-block;
          width: 47%;
          padding-left: 3%;
          height: 6.15rem;
          text-align: left;
        "
      >
        <el-col :span="12" class="text_big">室外温度</el-col>
        <el-col :span="8" :offset="1" class="value_big"
          >{{ outtemp }}℃</el-col
        >
        <el-col :span="12" class="text_big">室外湿度</el-col>
        <el-col :span="8" :offset="1" class="value_big"
          >{{ outhumid }}%</el-col
        >
        <el-col :span="9" class="text_big">含湿量</el-col>
        <el-col :span="11" :offset="1" class="value_big"
          >{{ calcHsl(outtemp, outhumid) }}g/Kg</el-col
        >
      </el-row>
      <el-row
        style="
          display: inline-block;
          width: 48%;
          padding-left: 3%;
          height: 6.15rem;
          text-align: left;
        "
      >
        <el-col :span="11" class="text_big">空气焓值</el-col>
        <el-col :span="9" :offset="1" class="value_big"
          >{{ calcHanZhi(outtemp, outhumid) }}Kj/Kg</el-col
        >
        <el-col :span="13" class="text_big">空气质量指数</el-col>
        <el-col :span="7" :offset="1" class="value_big"
          >{{ aqi }} ({{ aqilevel }})</el-col
        >
      </el-row>
    </div>
    <!-- 耗电监控 -->
    <div style="background: #000; width: 90%; height: 6.32rem; margin-left: 5%; padding-top: 3%; border-radius: 1.53rem; margin-top: 2rem; box-sizing: border-box; "
    >
      <div
        style="
          color: #15d04c;
          font-size: 12px;
          margin-bottom: 0.5rem;
          text-align: left;
          margin-left: 1rem
        "
      >
      耗电监控
      </div>
      <div
        v-if="!(project.aiodp&&project.aiodp.indexOf('acb')>=0)"
        style="
          color: #ffffff;
          font-size: 12px;
          text-align: left;
        "
      >
        <el-row
          style="
            display: inline-block;
            width: 47%;
            padding-left: 3%;
            height: 6.15rem;
            text-align: left;
          "
        >
          <el-col :span="12" class="text_big">昨日耗电</el-col>
          <el-col :span="8" :offset="1" class="value_big"
            >{{power.length>=2?Math.round(power[0].powerused) :0 }}度</el-col
          >
          <el-col :span="12" class="text_big">当前功率</el-col>
          <el-col :span="8" :offset="1" class="value_big"
            >{{ heatpump.reg0031||(Math.round(acb.voltage*acb.elecrt/100)/10)||0 }}kW</el-col
          >
        </el-row>
        <el-row
          style="
            display: inline-block;
            width: 48%;
            padding-left: 3%;
            height: 6.15rem;
            text-align: left;
          "
        >
          <el-col :span="12" class="text_big">今日耗电</el-col>
          <el-col :span="8" :offset="1" class="value_big"
            >{{ power.length>=2?Math.round(power[1].powerused):0 }}度</el-col
          >
          <el-col :span="13" class="text_big">当前电流</el-col>
          <el-col :span="7" :offset="1" class="value_big"
            >{{ heatpump.reg0028||acb.elecrt||0 }}A</el-col
          >
        </el-row>
      </div>
      <div v-else
          style="
          color: #ffffff;
          font-size: 12px;
          line-height: 20px;
        "
      >
        <el-col :span="8" :offset="8"  class="text_big">未添加相关传感器</el-col>
      </div>
    </div>
    <!-- 系统参数 输配工况 热泵工况 热泵体检表 -->
    <div style="width: 90%; margin: 0 auto; background: #000;border-radius: 1.53rem; margin-top: 2rem; padding-top: 3%; padding-bottom: 1.5rem">
      <!-- 系统参数 -->
      <el-row
        style="
          font-size: 12px;
          width: 96%;
          margin: 0 auto;
          text-align: left;
          background: #141517;
          border-radius: 1.54rem;
          padding-top: 3%;
          height: 6rem;
          margin-top: 0.77rem;
        "
      >
        <el-row
          style="
            display: inline-block;
            width: 47%;
            padding-left: 3%;
            height: 4.15rem;
            text-align: left;
          "
        >
          <el-col :span="12"
            style="
              color: #15d04c;
              font-size: 12px;
              "
          >系统状态</el-col>
          <el-col :span="8" :offset="1" class="value_big"
            ></el-col
          >
          <el-col :span="12" class="text_big">系统状态</el-col>
          <el-col :span="8" :offset="1" class="value_big"
            >{{ power.length>=2?Math.round(power[1].powerused):0 }}度</el-col
          >
          <el-col :span="14" class="text_big">相对湿度设置</el-col>
          <el-col :span="6" :offset="1" class="value_big"
            >{{ qlg.sethumi }}%</el-col
          >
        </el-row>
        <el-row
          style="
            display: inline-block;
            width: 48%;
            padding-left: 3%;
            height: 4.15rem;
            text-align: left;
          "
        >
          <el-col :span="12" class="text_big"></el-col>
          <el-col :span="8" :offset="1" class="value_big"
            ></el-col
          >
          <el-col v-if="false" :span="13" class="text_big">热水开关</el-col>
          <el-col v-if="false" :span="7" :offset="1" class="value_big"
            >{{ getDpText(heatpump, "hotwater") }}</el-col
          >
          <el-col v-if="false" :span="13" class="text_big">生活热水设置温度</el-col>
          <el-col v-if="false" :span="7" :offset="1" class="value_big"
            >{{ heatpump.settemp_hx }}℃</el-col
          >
          <el-col :span="11" class="text_big">模式设置</el-col>
          <el-col :span="9" :offset="1" class="value_big"
            >{{ getDpText(qlg, "mode") }}</el-col
          >
        </el-row>
      </el-row>
      <!-- 输配工况 热泵工况 -->
      <div
        style="font-size: 12px; width: 96%; margin: 0 auto; text-align: left; background: #141517; border-radius: 1.54rem; padding-top: 3%; height: 13rem; margin-top: 0.77rem; ">
        <!-- 输配工况 热泵工况 -->
        <el-row
          style="
            font-size: 12px;
            text-align: left;
            padding-left: 1rem
          "
        >
          <el-col :span="12" style="color: #15d04c; font-size: 12px;">输配工况</el-col>
          <el-col :span="12" style="color: #15d04c; font-size: 12px;">热泵工况</el-col>
          <el-col :span="5" class="text_big">模式</el-col>
          <el-col :span="5" :offset="1" class="value_big">{{
            getDpText(qlg, "mode")
          }}</el-col>
          <!-- <el-col  :span="6" :offset="1" class="text_big">供水压力</el-col>
          <el-col  :span="4" :offset="1" class="value_big">--</el-col> -->
            <el-col  :span="6" :offset="1" class="text_big">运行状态</el-col>
          <el-col  :span="4" :offset="1" class="value_big">{{getDpText(heatpump, "power")}}</el-col>
          <el-col :span="7" class="text_big">一次供水</el-col>
          <el-col :span="3" :offset="1" class="value_big"
            >{{ qlg.spjstemp }}℃</el-col
          >
          <el-col :span="7" :offset="1" class="text_big">母线电压</el-col>
          <el-col :span="3" :offset="1" class="value_big">{{heatpump.reg0070 || '--'}}V</el-col>
            <!-- <el-col  :span="7" :offset="1" class="text_big">回水压力</el-col>
          <el-col   :span="3" :offset="1" class="value_big"
            >--</el-col> -->
          <el-col :span="7" class="text_big">一次回水</el-col>
          <el-col :span="3" :offset="1" class="value_big"
            >{{ qlg.hphstemp }}℃</el-col
          >
          <el-col :span="7" :offset="1" class="text_big">制热设置温度</el-col>
          <el-col :span="3" :offset="1" class="value_big">{{ heatpump.settemp_ho }}℃</el-col>
          <el-col :span="7" class="text_big">二次供水</el-col>
          <el-col :span="3" :offset="1" class="value_big"
            >{{ qlg.mixtemp }}℃</el-col
          >
          <el-col :span="7" :offset="1" class="text_big">制冷设置温度</el-col>
          <el-col :span="3" :offset="1" class="value_big">{{ heatpump.settemp_co }}℃</el-col
          >
          <el-col :span="7" class="text_big">二次回水</el-col>
          <el-col :span="3" :offset="1" class="value_big"
            >{{ qlg.sphstemp }}℃</el-col
          >
          <el-col :span="7" :offset="1" class="text_big">循环水泵</el-col>
          <el-col :span="3" :offset="1" class="value_big">{{getDpText(heatpump, "reg0014")}}</el-col
          >
          <el-col :span="7" class="text_big">水泵状态</el-col>
          <el-col :span="3" :offset="1" class="value_big"
            >{{   getDpText(qlg, "spsbzt") }}</el-col
          >
          <el-col :span="7" :offset="1" class="text_big">压缩机频率</el-col>
          <el-col :span="3" :offset="1" class="value_big">{{ heatpump.cfrequency }}Hz</el-col
          >

        </el-row>
      </div>
      <!-- 美赑云端运维 -->
      <div
        style="
          font-size: 12px;
          width: 96%;
          margin: 0 auto;
          text-align: left;
          background: #141517;
          border-radius: 1.54rem;
          padding-top: 3%;
          height: 38rem;
          margin-top: 0.77rem;
        "
      >
        <el-row
          style="
            font-size: 12px;
            text-align: left;
            padding-left: 1rem
          "
        >
          <el-col :span="13" style="color: #15d04c; font-size: 12px;">美赑云端运维</el-col>
          <el-col :span="11" style="color: #15d04c; font-size: 12px;">参考值</el-col>
          
          <el-col :span="7" class="text_big">环境温度</el-col>
          <el-col :span="5" class="value_big">
            {{ heatpump.temp || '--' }}℃
          </el-col>
          <el-col :span="1" class="value_big_1">
            <i v-show="heatpump.temp > 45" class="el-icon-top"></i>
            <i v-show="heatpump.temp < 15" class="el-icon-bottom"></i>
          </el-col>
          <el-col :span="4" class="value_big_1">
            15~45
          </el-col>
          <el-col :span="7"  class="text_big"></el-col>
          
          <el-col :span="7" class="text_big">出水温度</el-col>
          <el-col :span="5" class="value_big">
            {{ heatpump.temp_o || '--' }}℃
          </el-col>
          <el-col :span="1" class="value_big_1">
            <i v-show="heatpump.temp_o > 20" class="el-icon-top"></i>
            <i v-show="heatpump.temp_o < 5" class="el-icon-bottom"></i>
          </el-col>
          <el-col :span="4" class="value_big_1">
            5~20
          </el-col>
          <el-col :span="7"  class="text_big"></el-col>

          <el-col :span="7" class="text_big">进水温度</el-col>
          <el-col :span="5" class="value_big">
            {{ heatpump.temp_b || '--' }}℃
          </el-col>
          <el-col :span="1" class="value_big_1">
            <i v-show="heatpump.temp_b > 30" class="el-icon-top"></i>
            <i v-show="heatpump.temp_b < 10" class="el-icon-bottom"></i>
          </el-col>
          <el-col :span="4" class="value_big_1">
            10~30
          </el-col>
          <el-col :span="7"  class="text_big"></el-col>

          <el-col :span="7" class="text_big">进出温差</el-col>
          <el-col :span="5" class="value_big">
            {{ Math.round(Math.abs(heatpump.temp_b-heatpump.temp_o)) || '--' }}℃
          </el-col>
          <el-col :span="1" class="value_big_1">
            <i v-show="Math.abs(heatpump.temp_b-heatpump.temp_o)> 9" class="el-icon-top"></i>
            <i v-show="Math.abs(heatpump.temp_b-heatpump.temp_o) < 2" class="el-icon-bottom"></i>
          </el-col>
          <el-col :span="4" class="value_big_1">
            2~9
          </el-col>
          <el-col :span="7"  class="text_big"></el-col>
          <el-col :span="7" class="text_big">中盘温度</el-col>
          <el-col :span="5" class="value_big">
            {{heatpump.zptemp || '--'}}℃
          </el-col>
          <el-col :span="1" class="value_big_1">
            <i v-show="heatpump.zptemp > 62" class="el-icon-top"></i>
            <i v-show="heatpump.zptemp < 45" class="el-icon-bottom"></i>
          </el-col>
          <el-col :span="4" class="value_big_1">
            45~62
          </el-col>
          <el-col :span="7" class="text_big"></el-col>
          <el-col :span="7" class="text_big">出盘温度</el-col>
          <el-col :span="5" class="value_big">
            {{heatpump.reg0044 || '--'}}℃
          </el-col>
          <el-col :span="12" class="text_big"></el-col>
          <el-col :span="7" class="text_big">排气温度</el-col>
          <el-col :span="5" class="value_big">
            {{heatpump.pqtemp || '--'}}℃
          </el-col>
          <el-col :span="1" class="value_big_1">
            <i v-show="heatpump.pqtemp > 105" class="el-icon-top"></i>
            <i v-show="heatpump.pqtemp < 45" class="el-icon-bottom"></i>
          </el-col>
          <el-col :span="4" class="value_big_1">
            45~105
          </el-col>
          <el-col :span="7"  class="text_big"></el-col>
          <el-col :span="7" class="text_big">吸气温度</el-col>
          <el-col :span="5" class="value_big">
            {{heatpump.reg0041 || '--'}}℃
          </el-col>
          <el-col :span="1" class="value_big_1">
            <!-- <i v-show="heatpump.reg0041 > 45" class="el-icon-top"></i>
            <i v-show="heatpump.reg0041 < 15" class="el-icon-bottom"></i> -->
          </el-col>
          <el-col :span="4" class="value_big_1">
            <!-- 15~45℃ -->
          </el-col>
          <el-col :span="7" class="text_big"></el-col>
          <el-col :span="7" class="text_big">排气过热度</el-col>
          <el-col :span="5" class="value_big">
            {{ heatpump.pxgr || '--' }}K
          </el-col>
          <el-col :span="1" class="value_big_1">
            <i v-show="heatpump.pxgr > 45" class="el-icon-top"></i>
            <i v-show="heatpump.pxgr < 15" class="el-icon-bottom"></i>
          </el-col>
          <el-col :span="4" class="value_big_1">
            15~45
          </el-col>
          <el-col :span="7" class="text_big"></el-col>
          <el-col :span="7" class="text_big">吸气过热度</el-col>
          <el-col :span="5" class="value_big">
            {{ heatpump.zxqgr || '--' }}K
          </el-col>
          <el-col :span="1" class="value_big_1">
            <i v-show="heatpump.zxqgr > 20" class="el-icon-top"></i>
            <i v-show="heatpump.zxqgr < 2" class="el-icon-bottom"></i>
          </el-col>
          <el-col :span="4" class="value_big_1">
            2~20
          </el-col>
          <el-col :span="7" class="text_big"></el-col>
          <el-col :span="7" class="text_big">吸气压力</el-col>
          <el-col :span="5" class="value_big">
            {{ heatpump.xqpressure || '--' }}bar
          </el-col>
          <el-col :span="1" class="value_big_1">
            <i v-show="heatpump.xqpressure > 12" class="el-icon-top"></i>
        <i v-show="heatpump.xqpressure < 7" class="el-icon-bottom"></i>
          </el-col>
          <el-col :span="4" class="value_big_1">
            7~12
          </el-col>
          <el-col :span="7" class="text_big"></el-col>
          <el-col :span="7" class="text_big">驱动模块</el-col>
          <el-col :span="5" class="value_big">
            {{ heatpump.moduletemp || '--' }}℃
          </el-col>
          <el-col :span="1" class="value_big_1">
            <i v-show="heatpump.moduletemp > 85" class="el-icon-top"></i>
        <i v-show="heatpump.moduletemp < 0" class="el-icon-bottom"></i>
          </el-col>
          <el-col :span="4" class="value_big_1">
            0~85
          </el-col>
        
          <el-col :span="7"  class="text_big"></el-col>
          <el-col :span="7" class="text_big">主膨胀阀步数</el-col>
          <el-col :span="5" class="value_big">
            {{ heatpump.reg0065||heatpump.reg0065===0?heatpump.reg0065:'--' }}PPS
          </el-col>
          <el-col :span="1" class="value_big_1">
          </el-col>
          <el-col :span="4" class="value_big_1">
          </el-col>
          <el-col :span="7"  class="text_big"></el-col>
          <el-col :span="7" class="text_big">辅膨胀阀步数</el-col>
          <el-col :span="5" class="value_big">
            {{ heatpump.reg0066||heatpump.reg0066===0?heatpump.reg0066:'--' }}PPS
          </el-col>
          <el-col :span="1" class="value_big_1">
          </el-col>
          <el-col :span="4" class="value_big_1">
          </el-col>
          <el-col :span="7"  class="text_big"></el-col>
          <el-col :span="7" class="text_big">空调循环泵</el-col>
          <el-col :span="5" class="value_big">
            {{ getDpText(heatpump, "reg0014") || '--' }}
          </el-col>
          <el-col :span="1" class="value_big_1">
          </el-col>
          <el-col :span="4" class="value_big_1">
          </el-col>
          <el-col :span="7"  class="text_big"></el-col>
          <el-col :span="7" class="text_big">压缩机频率</el-col>
          <el-col :span="5" class="value_big">
            {{ heatpump.cfrequency }}Hz
          </el-col>
          <el-col :span="1" class="value_big_1">
          </el-col>
          <el-col :span="4" class="value_big_1">
          </el-col>
          <el-col :span="7"  class="text_big"></el-col>
          <el-col :span="7" class="text_big">压缩机电流</el-col>
          <el-col :span="5" class="value_big">
            {{ heatpump.compel }}A
          </el-col>
          <el-col :span="1" class="value_big_1">
          </el-col>
          <el-col :span="4" class="value_big_1">
          </el-col>
          <el-col :span="7" class="text_big"></el-col>
          <el-col :span="7" class="text_big">机组电流</el-col>
          <el-col :span="5" class="value_big">
            {{ '--' }}A
          </el-col>
          <el-col :span="1" class="value_big_1">
          </el-col>
          <el-col :span="4" class="value_big_1">
          </el-col>
          <el-col :span="7"  class="text_big"></el-col>
          <el-col :span="7" class="text_big">风机1转速</el-col>
          <el-col :span="5" class="value_big">
            {{ heatpump.reg0049 }}RPM
          </el-col>
          <el-col :span="1" class="value_big_1">
          </el-col>
          <el-col :span="4" class="value_big_1">
          </el-col>
          <el-col :span="7"  class="text_big"></el-col>
          <el-col :span="7" class="text_big">风机2转速</el-col>
          <el-col :span="5" class="value_big">
            {{ heatpump.reg0050 }}RPM
          </el-col>
          <el-col :span="1" class="value_big_1">
          </el-col>
          <el-col :span="4" class="value_big_1">
          </el-col>
          <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('fjjqgr')>=0)" :span="7"  class="text_big"></el-col>
          <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('fjjqgr')>=0)" :span="7" class="text_big">经济器过热度</el-col>
          <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('fjjqgr')>=0)" :span="5" class="value_big">
            {{ heatpump.fjjqgr||heatpump.fjjqgr===0?heatpump.fjjqgr:'--' }}℃
          </el-col>

          <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('fjjqgr')>=0)" :span="1" class="value_big_1">
            <i v-show="heatpump.fjjqgr > 6" class="el-icon-top"></i>
            <i v-show="heatpump.fjjqgr < 1" class="el-icon-bottom"></i>
          </el-col>
          <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('fjjqgr')>=0)" :span="4" class="value_big_1">
            1~6
          </el-col>
          <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('reg0045')>=0)" :span="7"  class="text_big"></el-col>
          <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('reg0045')>=0)" :span="7" class="text_big">经济器进口</el-col>
          <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('reg0045')>=0)" :span="5" class="value_big">
            {{ heatpump.reg0045||heatpump.reg0045===0?heatpump.reg0045:'--' }}℃
          </el-col>

          <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('reg0045')>=0)" :span="1" class="value_big_1">
            <i v-show="heatpump.reg0045 > 50" class="el-icon-top"></i>
            <i v-show="heatpump.reg0045 < 10" class="el-icon-bottom"></i>
          </el-col>
          <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('reg0045')>=0)" :span="4" class="value_big_1">
            10~50
          </el-col>
          <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('reg0046')>=0)"  :span="7"  class="text_big"></el-col>
          <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('reg0046')>=0)"  :span="7" class="text_big">经济器出口</el-col>
          <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('reg0046')>=0)"  :span="5" class="value_big">
            {{ heatpump.reg0046||heatpump.reg0046===0?heatpump.reg0046:'--' }}℃
          </el-col>
          <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('reg0046')>=0)"  :span="1" class="value_big_1">
            <i v-show="heatpump.reg0046 > 55" class="el-icon-top"></i>
            <i v-show="heatpump.reg0046 < 25" class="el-icon-bottom"></i>
          </el-col>
          <el-col v-if="!(project.aiodp&&project.aiodp.indexOf('reg0046')>=0)"  :span="4" class="value_big_1">
            25~55
          </el-col>
          <el-col :span="7" :offset="1" class="text_big"></el-col>
        </el-row>
      </div>
      <!-- 故障信息 -->
    <el-row
      style="
        width: 6rem;
        height: 1.6rem;
        line-height: 1.6rem;
        color:#B3B3B3;
        border: 0;
        font-size:12px;
        cursor: pointer;
        background: #141517;
        border-radius: 0.4rem;
        margin-left: 0.6rem;
        margin-top: 1rem;
      "
      @click.native="openError()"
      >故障信息</el-row
    >
    </div>
    <el-dialog
      title="故障历史 (最近100条)"
      :visible.sync="dialogTableVisible"
      width="400px"
    >
      <el-table
        :data="gridData"
        stripe
        border
        height="250"
        :header-cell-style="{ padding: '2px' }"
        :cell-style="{ padding: '5px' }"
      >
        <el-table-column property="createdtime" label="日期"></el-table-column>
        <el-table-column property="errmsg" label="故障内容"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
  <div class="anniu" v-if="isMobile">
    <el-button class="but" type="success" round size="mini" @click="energySH()">曲线</el-button>
  </div>
  <el-alert
    v-if="tanchuang"
    @close="ale"
    class="aler"
    style="
      width: 37rem;
      height: auto;
      z-index: 2;
      background-color: rgba(0, 0, 0, 0.95);
      border: 1px solid #5e5656;
      position: absolute;
      top: 5%;
      left: 35.5%;
      padding: 0 0 1rem 0;
      border-radius: 1rem;
    "
  >
    <el-row
      style="
        height: 2.5rem;
        line-height: 2.5rem;
        background-color: #5e5f66;
        font-size: 1.23rem;
        color: #ffffff;
    ">
      <el-col>
        设备耗电
      </el-col>
    </el-row>
    <el-row style="width:100%;">
      <el-col style="height:50px;line-height:50px;text-align:left" :offset="2">
        <el-date-picker
          v-model="value1"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00','23:59:59']"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-col>
      <el-col :span="6" :offset="17">
        <el-button icon="el-icon-search" size="small" type="warning" @click="energy()" style="margin-left: 0.5rem;">查询</el-button>
      </el-col>
    </el-row>
    <div id="energy" style="width: 35rem;height:20rem; margin: 0 auto"></div>
  </el-alert>
</div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Device',
  props: ['isMobile'],
  data () {
    return {
      project: {},
      mibeeOnline: false,
      tanchuang: false,
      onlineTimeout: null,
      uploadtime: null,
      errorlist: [],
      devicelist: [],
      outtemp: null,
      outhumid: null,
      aqi: null,
      dialogTableVisible: false,
      gridData: [],
      power: {},
      // isMobile: true
      value1: [],
      qlg: {},
      heatpump: {}
    }
  },
  watch: {
    isMobile: function (val) {
      var self = this
      setTimeout(function () {
        self.drawViaMibee()
      }, 2000) // 接收父组件的值
    },
    qlg:function(val){
      console.log('qlg:'+val.reg12032)
    }
  },
  computed: {
    errortext: function () {
      return (
        '当前miBEE主机离线，页面展示数据最后更新时间为：' +
        (this.uploadtime || (this.qlg ? this.qlg.uploadtime : ''))
      )
    },
    aqilevel: function () {
      if (this.aqi <= 50) {
        return '优'
      } else if (this.aqi <= 100) {
        return '良'
      } else if (this.aqi <= 150) {
        return '轻度污染'
      } else if (this.aqi <= 200) {
        return '中度污染'
      } else if (this.aqi <= 300) {
        return '重度污染'
      } else {
        return '严重污染'
      }
    },
    // 广东候鸟
    gdhn: function () {
      if (this.project.projectid == '245977d4-19e2-4d20-98a9-97db3037fed5') {
        return true
      } else {
        return false
      }
    },
    //广东候鸟特殊处理的湿度
    gdhns:function(){
      if (this.project.projectid == '245977d4-19e2-4d20-98a9-97db3037fed5') {
        let dev = this.devicelist.filter((d) => {
          return d.deviceid===34375425
        })
      if (dev && dev.length > 0) {
        return dev[0]
      } else {
        return {}
      }
      } else {
        return {}
      }
    },
    // 新风——4G
    xfG4: function () {
      let dev = this.devicelist.filter((d) => {
        return d.deviceid == 17564161
      })
      if (dev && dev.length > 0) {
        return dev[0]
      } else {
        return {}
      }
    },
    // 全联供空调
    qlgList: function () {
      let dev = this.devicelist.filter((d) => {
        return d.protocolid == 227
      })
      if (dev && dev.length > 0) {
        return dev
      } else {
        return []
      }
    },
    // 除湿机
    dehum: function () {
      console.log(this.qlg.reg12032)
      let dev = this.devicelist.filter((d) => {
        return d.protocolid == 229 && (!d.subdevs||d.subdevs==((this.qlg.reg12032||0)+1))
      })
     
      if (dev && dev.length > 0) {
        dev.sort((a, b) => { return a.deviceid - b.deviceid })
        console.log(dev[0].deviceid)
        return dev[0]
      } else {
        let h = this.devicelist.filter((d) => {
          return d.type === 'freshair'
        })
        if (h && h.length > 0) {
          return h[0]
        } else {
          return []
        }
      }
    },
    heatpumpList: function () {
      let dev = this.devicelist.filter((d) => {
        return d.protocolid == 222
      })
      if (dev && dev.length > 0) {
        return dev
      } else {
        dev = this.devicelist.filter((d) => {
          return d.type == 'heatpump'
        })
        if (dev && dev.length > 0) {
          return dev
        } else {
          return []
        }
      }
    },

    temp_b_o: function () {
      let dev = 0
      if (this.heatpump.temp_b && this.heatpump.temp_o) {
        if (this.heatpump.temp_b <= this.heatpump.temp_o) {
          dev = this.heatpump.temp_o - this.heatpump.temp_b
        } else {
          dev = this.heatpump.temp_b - this.heatpump.temp_o
        }
        if (dev == 0) {
          return dev
        } else {
          return dev.toFixed(1)
        }
      } else {
        return '--'
      }
    },
    // 空开或电表
    acb: function () {
      let dev = this.devicelist.filter((d) => {
        return d.type == 'acb'
      })
      if (dev && dev.length > 0) {
        return dev[0]
      } else {
        return {}
      }
    },
    qlgTemp: function () {
      if (this.qlg.innerid) {
        if (this.qlg.mode == 2) {
          return this.qlg.mixsettemp_h
        } else {
          return this.qlg.mixsettemp_c
        }
      } else {
        return ''
      }
    },
    zs:function(){
        if(!this.qlg.dplist){
          return {text:'--',value:'--'}
        }
        let dp= this.qlg.dplist.filter(d=>{return d.dpid===(this.qlg.hexagon3||132)})
        if(dp&&dp.length==1){
          let unit=dp[0].unit
          if(dp[0].unit=='天'){
          unit=''}
          return {text:dp[0].desc+' '+unit,value:this.qlg[dp[0].name]}
        }
      
      return {text:'--',value:'--'}
    },
    ys:function(){
      if(!this.qlg.dplist){
          return {text:'--',value:'--'}
        }
        let dp= this.qlg.dplist.filter(d=>{return d.dpid===(this.qlg.hexagon4||133)})
        if(dp&&dp.length==1){
          let unit=dp[0].unit
          if(dp[0].unit=='天'){
          unit=''}
          return {text:dp[0].desc+' '+unit,value:this.qlg[dp[0].name]}
        }
      
      return {text:'--',value:'--'}
    },
    zx:function(){
      if(!this.qlg.dplist){
          return {text:'--',value:'--'}
        }
        let dp= this.qlg.dplist.filter(d=>{return d.dpid===(this.qlg.hexagon5||134)})
        if(dp&&dp.length==1){
          let unit=dp[0].unit
          if(dp[0].unit=='天'){
          unit=''}
          return {text:dp[0].desc+' '+unit,value:this.qlg[dp[0].name]}
        }
      
      return {text:'--',value:'--'}
    },
    yx:function(){
      if(!this.qlg.dplist){
          return {text:'--',value:'--'}
        }
        let dp= this.qlg.dplist.filter(d=>{return d.dpid===(this.qlg.hexagon6||137)})
        if(dp&&dp.length==1){
          let unit=dp[0].unit
          if(dp[0].unit=='天'){
          unit=''}
          return {text:dp[0].desc+' '+unit,value:this.qlg[dp[0].name]}
        }
      
      return {text:'--',value:'--'}
    }
  },
  mounted: function () {
    document.getElementsByTagName('html')[0].style.fontSize = '13px'
    if (this.$isMobile()) {
      this.isMobile = false
    } else {
      this.isMobile = true
    }
    let project = window.localStorage.getItem('project')
    // let yesterday = new Date()
    // let timestamp1=new Date(new Date().toLocaleDateString());
    // timestamp1.getTime()
    // console.log(new Date(new Date().toLocaleDateString()))
    // timestamp1.setDate(timestamp1.getDate() - 6)
    var today = new Date()
    today.setHours(0)
    today.setMinutes(0)
    today.setSeconds(0)
    today.setMilliseconds(0)
    var myDate = today
    var premon = myDate.setDate(myDate.getDate() - 6)
    this.value1 = [new Date(premon).Format('yyyy-MM-dd HH:mm:00'), (new Date()).Format('yyyy-MM-dd HH:mm:00')]
    // debugger
    if (project) {
      this.project = JSON.parse(project)
      if (this.project.innerid != this.project.projectid) {
        this.project.innerid = this.project.projectid
      }
      // alert(JSON.stringify(this.project))
    } else {
      this.$router.push({ name: 'Login' })
      return
    }

    this.Common.connentMqtt(this.Common.newGuid())
    let self = this

    Vue.axios.post('/api/cchv/errorcode/list', {}).then((res) => {
      if (res.data.errcode == 0) {
        self.errorlist = res.data.msgbody.dev_errorcode
      }
    })

    Vue.axios
      .post('/api/cchv/device/list', {
        projectid: this.project.innerid
      })
      .then((res) => {
        if (res.data.errcode == 0) {
          self.devicelist = res.data.msgbody
          let t = self.devicelist.filter((d) => {
            return d.protocolid == 227
          })

          if (t && t.length > 0) {
            self.qlg = t[0]
          }
          t = self.devicelist.filter((d) => {
            return d.protocolid == 222
          })
          if (t && t.length > 0) {
            self.heatpump = t[0]
          } else {
            t = self.devicelist.filter((d) => {
              return d.type == 'heatpump'
            })
            if (t && t.length > 0) {
              self.heatpump = t[0]
            }
          }

          Vue.axios
            .post('/api/cchv/errorhistory/query', {
              deviceid: self.heatpump.innerid
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.gridData = res.data.msgbody
              }
            })
          Vue.axios.post('/api/cchv/power/query', {deviceid: this.acb.innerid || this.heatpump.innerid}).then((res) => {
            if (res.data.errcode == 0) {
              self.power = res.data.msgbody
            }
          })
          setTimeout(function () {
            self.drawViaMibee()
            self.Common.mqttReceive(
              [
                'device/' + self.project.srcaddress + '/broadcast',
                'device/' + self.project.srcaddress + '/' +
                  self.Common.mqttClientid
              ],
              function (msg) {
                // 主机只要收到消息就表明在线，70s内无消息则离线
                self.mibeeOnline = true
                if (self.onlineTimeout) {
                  clearTimeout(self.onlineTimeout)
                  self.onlineTimeout = null
                }
                self.onlineTimeout = setTimeout(function () {
                  self.mibeeOnline = false
                }, 70 * 1000)

                msg = JSON.parse(msg.payloadString)
                for (var key in msg) {
                  if (key == 'dpchange' || key == 'devdpmsg') {
                    self.uploadtime = new Date().Format('yyyy-MM-dd HH:mm:ss')
                    var dev = self.devicelist.filter((x) => {
                      if (key == 'dpchange') {
                        return x.deviceid == msg.dpchange.devid
                      } else {
                        return x.deviceid == msg.devdpmsg.devid
                      }
                    })
                    if (dev && dev.length > 0) {
                      if (msg.dpchange.dpid == 9000) {
                        dev[0].online = msg[key].data
                      } else if (msg.dpchange.dpid == 9003) {
                      } else if (msg.dpchange.dpid == 9009) {
                        console.log(msg.dpchange)
                        if (msg.dpchange.data == 0) {
                          dev[0].errmsg = ''
                        } else {
                          if (self.errorlist && self.errorlist.length > 0) {
                            let error = self.errorlist.filter((x) => {
                              return (
                                x.protocolid.indexOf(dev[0].protocolid) >= 0
                              )
                            })
                            if (error && error.length > 0) {
                              let err = error[0].errorlist.filter((e) => {
                                return e.code == msg.dpchange.data
                              })
                              if (err && err.length > 0) {
                                dev[0].errmsg = err[0].desc
                              } else {
                                dev[0].errmsg = '未知故障'
                              }
                            } else {
                              dev[0].errmsg = '未知故障'
                            }
                          } else {
                            dev[0].errmsg = '未知故障'
                          }
                        }
                      } else {
                        let dp = dev[0].dplist.filter((d) => {
                          return d.dpid === msg[key].dpid
                        })
                        if (dp && dp.length > 0) {
                          if (
                            dp[0].name === 'lgtpwr' ||
                            dp[0].name === 'lnrdimpwr'
                          ) {
                            dev[0].power = msg[key].data
                          }
                          dev[0][dp[0].name] =
                            Math.round(msg[key].data * 10) / 10

                          if (dp[0].name.indexOf('grdtlv') >= 0) {
                            self.drawViaMibee()
                          }
                        }
                      }
                    }
                  } else if (key === 'dpsync') {
                    msg.dpsync.forEach((o) => {
                      var dev = self.devicelist.filter((x) => {
                        return x.deviceid === o.devid
                      })
                      if (dev && dev.length > 0) {
                        for (let key in o.dplist) {
                          if (key == '9000') {
                            dev[0].online = o.dplist[key]
                          } else if (key == '9003') {
                            dev[0].signal = o.dplist[key]
                          } else {
                            let dp = dev[0].dplist.filter((d) => {
                              return d.dpid == parseInt(key)
                            })
                            if (dp && dp.length > 0) {
                              if (
                                dp[0].name == 'lgtpwr' ||
                                dp[0].name == 'lnrdimpwr'
                              ) {
                                dev[0].power = o.dplist[key]
                              }
                              dev[0][dp[0].name] =
                                Math.round(o.dplist[key] * 10) / 10
                                if (dp[0].name.indexOf('grdtlv') >= 0) {
                            self.drawViaMibee()
                          }
                            }
                          }
                        }
                      }
                    })
                  }
                }
              }
            )
            let obj = { getAllDevOnlineSta: {} }
            self.Common.mqttSend(
              self.project.srcaddress,
              obj,
              function (msg) {}
            )
            obj = { getAllDevAllDpSta: 'save' }
            self.Common.mqttSend(
              self.project.srcaddress,
              obj,
              function (msg) {}
            )
            obj = { sysheart: 'null' }
            self.Common.mqttSend(
              self.project.srcaddress,
              obj,
              function (msg) {}
            )
          }, 2000)
        }
      })
    if (self.project.pcity || self.project.city || (self.project.ip && self.project.ip != '127.0.0.1')) {
      Vue.axios.post('/api/weather', { weaid: (self.project.pcity || self.project.city || self.project.ip) }).then((res) => {
        if (res.data.errcode == 0) {
          self.outtemp = res.data.msgbody.temp
          self.outhumid = res.data.msgbody.humidity
          self.aqi = res.data.msgbody.aqi
        }
      })
    }

    setInterval(function () {
      let obj = { sysheart: 'null' }
      self.Common.mqttSend(
        self.project.srcaddress,
        obj,
        function (msg) {}
      )
    }, 30 * 1000)
  },
  destroyed: function () {
    this.Common.closeMqtt()
  },
  methods: {
    openError(){
      Vue.axios
            .post('/api/cchv/errorhistory/query', {
              deviceid: this.heatpump.innerid
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                this.gridData = res.data.msgbody
              }
            })
      this.dialogTableVisible=true;

    },
    energy () {
      let myCharts = echarts.init(document.getElementById('energy'))
      if (this.value1 && this.value1.length == 2) {
        Vue.axios
          .post('report/acb/daily/query', {deviceid: (this.acb.innerid || this.heatpump.innerid), startdate: this.value1[0], enddate: this.value1[1] })
          .then((res) => {
            if (res.data.errcode == 0) {
              myCharts.setOption(loadEcharts(res.data.msgbody))
              myCharts.resize()
            }
          })
      } else {
        this.$message({
          message: '请输入查询时间范围',
          type: 'warning'
        })
      }
    },
    energySH () {
      var self = this
      this.tanchuang = true
      setTimeout(function () {
        self.energy()
      }, 1000)
    },
    SH () {
      this.tanchuang = false
    },
    ale () {
      this.tanchuang = false
    },
    draw () {
      const win_wid = window.innerWidth
      const co2list = [
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 6.8],
          [(win_wid / 1920) * 16 * 6.2, (win_wid / 1920) * 16 * 9.7]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 5.2],
          [(win_wid / 1920) * 16 * 4.8, (win_wid / 1920) * 16 * 8.9]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 3.6],
          [(win_wid / 1920) * 16 * 3.4, (win_wid / 1920) * 16 * 8.1]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 2.0],
          [(win_wid / 1920) * 16 * 2, (win_wid / 1920) * 16 * 7.3]
        ]
      ]

      const humidList = [
        [
          [(win_wid / 1920) * 16 * 6.2, (win_wid / 1920) * 16 * 9.7],
          [(win_wid / 1920) * 16 * 6.2, (win_wid / 1920) * 16 * 15.6]
        ],
        [
          [(win_wid / 1920) * 16 * 4.8, (win_wid / 1920) * 16 * 8.9],
          [(win_wid / 1920) * 16 * 4.8, (win_wid / 1920) * 16 * 16.4]
        ],
        [
          [(win_wid / 1920) * 16 * 3.4, (win_wid / 1920) * 16 * 8.1],
          [(win_wid / 1920) * 16 * 3.4, (win_wid / 1920) * 16 * 17.2]
        ],
        [
          [(win_wid / 1920) * 16 * 2, (win_wid / 1920) * 16 * 7.3],
          [(win_wid / 1920) * 16 * 2, (win_wid / 1920) * 16 * 18]
        ]
      ]

      const srList = [
        [
          [(win_wid / 1920) * 16 * 6.2, (win_wid / 1920) * 16 * 15.6],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 18.5]
        ],
        [
          [(win_wid / 1920) * 16 * 4.8, (win_wid / 1920) * 16 * 16.4],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 20.1]
        ],
        [
          [(win_wid / 1920) * 16 * 3.4, (win_wid / 1920) * 16 * 17.2],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 21.7]
        ],
        [
          [(win_wid / 1920) * 16 * 2, (win_wid / 1920) * 16 * 18],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 23.4]
        ]
      ]

      const lwList = [
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 18.5],
          [(win_wid / 1920) * 16 * 16.3, (win_wid / 1920) * 16 * 15.6]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 20.1],
          [(win_wid / 1920) * 16 * 17.7, (win_wid / 1920) * 16 * 16.4]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 21.7],
          [(win_wid / 1920) * 16 * 19.1, (win_wid / 1920) * 16 * 17.2]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 23.4],
          [(win_wid / 1920) * 16 * 20.5, (win_wid / 1920) * 16 * 18]
        ]
      ]

      const tempList = [
        [
          [(win_wid / 1920) * 16 * 16.3, (win_wid / 1920) * 16 * 15.6],
          [(win_wid / 1920) * 16 * 16.3, (win_wid / 1920) * 16 * 9.7]
        ],
        [
          [(win_wid / 1920) * 16 * 17.7, (win_wid / 1920) * 16 * 16.4],
          [(win_wid / 1920) * 16 * 17.7, (win_wid / 1920) * 16 * 8.9]
        ],
        [
          [(win_wid / 1920) * 16 * 19.1, (win_wid / 1920) * 16 * 17.2],
          [(win_wid / 1920) * 16 * 19.1, (win_wid / 1920) * 16 * 8.1]
        ],
        [
          [(win_wid / 1920) * 16 * 20.5, (win_wid / 1920) * 16 * 18],
          [(win_wid / 1920) * 16 * 20.5, (win_wid / 1920) * 16 * 7.3]
        ]
      ]

      const pm25List = [
        [
          [(win_wid / 1920) * 16 * 16.3, (win_wid / 1920) * 16 * 9.7],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 6.8]
        ],
        [
          [(win_wid / 1920) * 16 * 17.7, (win_wid / 1920) * 16 * 8.9],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 5.2]
        ],
        [
          [(win_wid / 1920) * 16 * 19.1, (win_wid / 1920) * 16 * 8.1],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 3.6]
        ],
        [
          [(win_wid / 1920) * 16 * 20.5, (win_wid / 1920) * 16 * 7.3],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 2.0]
        ]
      ]

      var c = document.getElementById('qlg')
      c.height = (win_wid / 1920) * 16 * 25.5
      c.width = (win_wid / 1920) * 16 * 22.5
      var ctx = c.getContext('2d')

      let colorlevel = 0
      let co2level = 0
      let pm25level = 0
      let templevel = 0
      let humidlevel = 0
      let lwlevel = 0
      let rslevel = 0
      if (this.gdhn) {
        if (this.xfG4.snrco2 < 700) {
          co2level = 0
        } else if (this.xfG4.snrco2 < 1000) {
          co2level = 1
        } else if (this.xfG4.snrco2 < 1500) {
          co2level = 2
        } else {
          co2level = 3
        }
        if (colorlevel < co2level) {
          colorlevel = co2level
        }

        if (this.xfG4['snrpm2.5'] < 25) {
          pm25level = 0
        } else if (this.xfG4['snrpm2.5'] < 37.5) {
          pm25level = 1
        } else if (this.xfG4['snrpm2.5'] < 75) {
          pm25level = 2
        } else {
          pm25level = 3
        }
        if (colorlevel < pm25level) {
          colorlevel = pm25level
        }

        if (Math.abs(this.xfG4.innertemp - 26) <= 2) {
          templevel = 0
        } else if (Math.abs(this.xfG4.innertemp - 26) <= 4) {
          templevel = 1
        } else if (Math.abs(this.xfG4.innertemp - 26) <= 6) {
          templevel = 2
        } else {
          templevel = 3
        }
        if (colorlevel < templevel) {
          colorlevel = templevel
        }

        if (this.xfG4.innerhumid >= 40 && this.xfG4.innerhumid <= 60) {
          humidlevel = 0
        } else if (this.xfG4.innerhumid >= 30 && this.xfG4.innerhumid <= 70) {
          humidlevel = 1
        } else if (this.xfG4.innerhumid >= 20 && this.xfG4.innerhumid <= 80) {
          humidlevel = 2
        } else {
          humidlevel = 3
        }
        if (colorlevel < humidlevel) {
          colorlevel = humidlevel
        }

        if (this.xfG4.filterAused <= 60) {
          lwlevel = 0
        } else if (this.xfG4.filterAused <= 105) {
          lwlevel = 1
        } else if (this.xfG4.filterAused <= 150) {
          lwlevel = 2
        } else {
          lwlevel = 3
        }
        if (colorlevel < lwlevel) {
          colorlevel = lwlevel
        }
        if (colorlevel <= 1) {
          ctx.strokeStyle = '#41BB79'
        } else if (colorlevel == 2) {
          ctx.strokeStyle = '#F4C01C'
        } else {
          ctx.strokeStyle = '#E0510A'
        }
      } else {
        if (this.qlg.snrco2 < 700) {
          co2level = 0
        } else if (this.qlg.snrco2 < 1000) {
          co2level = 1
        } else if (this.qlg.snrco2 < 1500) {
          co2level = 2
        } else {
          co2level = 3
        }
        if (colorlevel < co2level) {
          colorlevel = co2level
        }

        if (this.qlg['snrpm2.5'] < 25) {
          pm25level = 0
        } else if (this.qlg['snrpm2.5'] < 37.5) {
          pm25level = 1
        } else if (this.qlg['snrpm2.5'] < 75) {
          pm25level = 2
        } else {
          pm25level = 3
        }
        if (colorlevel < pm25level) {
          colorlevel = pm25level
        }

        if (Math.abs(this.qlg.snrtemp - 26) <= 2) {
          templevel = 0
        } else if (Math.abs(this.qlg.snrtemp - 26) <= 4) {
          templevel = 1
        } else if (Math.abs(this.qlg.snrtemp - 26) <= 6) {
          templevel = 2
        } else {
          templevel = 3
        }
        if (colorlevel < templevel) {
          colorlevel = templevel
        }

        if (this.qlg.snrhumi >= 40 && this.qlg.snrhumi <= 60) {
          humidlevel = 0
        } else if (this.qlg.snrhumi >= 30 && this.qlg.snrhumi <= 70) {
          humidlevel = 1
        } else if (this.qlg.snrhumi >= 20 && this.qlg.snrhumi <= 80) {
          humidlevel = 2
        } else {
          humidlevel = 3
        }
        if (colorlevel < humidlevel) {
          colorlevel = humidlevel
        }

        if (this.dehum.filterAused <= 60) {
          lwlevel = 0
        } else if (this.dehum.filterAused <= 105) {
          lwlevel = 1
        } else if (this.dehum.filterAused / 30 <= 150) {
          lwlevel = 2
        } else {
          lwlevel = 3
        }
        if (colorlevel < lwlevel) {
          colorlevel = lwlevel
        }
        if (colorlevel <= 1) {
          ctx.strokeStyle = '#41BB79'
        } else if (colorlevel == 2) {
          ctx.strokeStyle = '#F4C01C'
        } else {
          ctx.strokeStyle = '#E0510A'
        }
      }

      ctx.lineWidth = 2
      ctx.moveTo(co2list[co2level][0][0], co2list[co2level][0][1])
      ctx.lineTo(co2list[co2level][1][0], co2list[co2level][1][1])
      ctx.lineTo(humidList[humidlevel][0][0], humidList[humidlevel][0][1])
      ctx.lineTo(humidList[humidlevel][1][0], humidList[humidlevel][1][1])
      ctx.lineTo(srList[rslevel][0][0], srList[rslevel][0][1])
      ctx.lineTo(srList[rslevel][1][0], srList[rslevel][1][1])
      ctx.lineTo(lwList[lwlevel][0][0], lwList[lwlevel][0][1])
      ctx.lineTo(lwList[lwlevel][1][0], lwList[lwlevel][1][1])
      ctx.lineTo(tempList[templevel][0][0], tempList[templevel][0][1])
      ctx.lineTo(tempList[templevel][1][0], tempList[templevel][1][1])
      ctx.lineTo(pm25List[pm25level][0][0], pm25List[pm25level][0][1])
      ctx.lineTo(pm25List[pm25level][1][0], pm25List[pm25level][1][1])
      ctx.lineTo(co2list[co2level][0][0], co2list[co2level][0][1])
      ctx.stroke()
    },
    drawViaMibee () {
      const win_wid = window.innerWidth
      const zslist = [
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 6.8],
          [(win_wid / 1920) * 16 * 6.2, (win_wid / 1920) * 16 * 9.7]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 5.2],
          [(win_wid / 1920) * 16 * 4.8, (win_wid / 1920) * 16 * 8.9]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 3.6],
          [(win_wid / 1920) * 16 * 3.4, (win_wid / 1920) * 16 * 8.1]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 2.0],
          [(win_wid / 1920) * 16 * 2, (win_wid / 1920) * 16 * 7.3]
        ]
      ]

      const humidList = [
        [
          [(win_wid / 1920) * 16 * 6.2, (win_wid / 1920) * 16 * 9.7],
          [(win_wid / 1920) * 16 * 6.2, (win_wid / 1920) * 16 * 15.6]
        ],
        [
          [(win_wid / 1920) * 16 * 4.8, (win_wid / 1920) * 16 * 8.9],
          [(win_wid / 1920) * 16 * 4.8, (win_wid / 1920) * 16 * 16.4]
        ],
        [
          [(win_wid / 1920) * 16 * 3.4, (win_wid / 1920) * 16 * 8.1],
          [(win_wid / 1920) * 16 * 3.4, (win_wid / 1920) * 16 * 17.2]
        ],
        [
          [(win_wid / 1920) * 16 * 2, (win_wid / 1920) * 16 * 7.3],
          [(win_wid / 1920) * 16 * 2, (win_wid / 1920) * 16 * 18]
        ]
      ]

      const zxList = [
        [
          [(win_wid / 1920) * 16 * 6.2, (win_wid / 1920) * 16 * 15.6],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 18.5]
        ],
        [
          [(win_wid / 1920) * 16 * 4.8, (win_wid / 1920) * 16 * 16.4],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 20.1]
        ],
        [
          [(win_wid / 1920) * 16 * 3.4, (win_wid / 1920) * 16 * 17.2],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 21.7]
        ],
        [
          [(win_wid / 1920) * 16 * 2, (win_wid / 1920) * 16 * 18],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 23.4]
        ]
      ]

      const yxList = [
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 18.5],
          [(win_wid / 1920) * 16 * 16.3, (win_wid / 1920) * 16 * 15.6]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 20.1],
          [(win_wid / 1920) * 16 * 17.7, (win_wid / 1920) * 16 * 16.4]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 21.7],
          [(win_wid / 1920) * 16 * 19.1, (win_wid / 1920) * 16 * 17.2]
        ],
        [
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 23.4],
          [(win_wid / 1920) * 16 * 20.5, (win_wid / 1920) * 16 * 18]
        ]
      ]

      const tempList = [
        [
          [(win_wid / 1920) * 16 * 16.3, (win_wid / 1920) * 16 * 15.6],
          [(win_wid / 1920) * 16 * 16.3, (win_wid / 1920) * 16 * 9.7]
        ],
        [
          [(win_wid / 1920) * 16 * 17.7, (win_wid / 1920) * 16 * 16.4],
          [(win_wid / 1920) * 16 * 17.7, (win_wid / 1920) * 16 * 8.9]
        ],
        [
          [(win_wid / 1920) * 16 * 19.1, (win_wid / 1920) * 16 * 17.2],
          [(win_wid / 1920) * 16 * 19.1, (win_wid / 1920) * 16 * 8.1]
        ],
        [
          [(win_wid / 1920) * 16 * 20.5, (win_wid / 1920) * 16 * 18],
          [(win_wid / 1920) * 16 * 20.5, (win_wid / 1920) * 16 * 7.3]
        ]
      ]

      const ysList = [
        [
          [(win_wid / 1920) * 16 * 16.3, (win_wid / 1920) * 16 * 9.7],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 6.8]
        ],
        [
          [(win_wid / 1920) * 16 * 17.7, (win_wid / 1920) * 16 * 8.9],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 5.2]
        ],
        [
          [(win_wid / 1920) * 16 * 19.1, (win_wid / 1920) * 16 * 8.1],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 3.6]
        ],
        [
          [(win_wid / 1920) * 16 * 20.5, (win_wid / 1920) * 16 * 7.3],
          [(win_wid / 1920) * 16 * 11.25, (win_wid / 1920) * 16 * 2.0]
        ]
      ]

      var c = document.getElementById('qlg')
      c.height = (win_wid / 1920) * 16 * 25.5
      c.width = (win_wid / 1920) * 16 * 22.5
      var ctx = c.getContext('2d')

      let colorlevel = 0
      let zslevel = this.qlg.grdtlv3 || 0
      let yslevel = this.qlg.grdtlv4 || 0
      let templevel = this.qlg.grdtlv2 || 0
      let humidlevel = this.qlg.grdtlv1 || 0
      let yxlevel = this.qlg.grdtlv6 || 0
      let zxlevel = this.qlg.grdtlv5 || 0
      if (this.gdhn) {
        if (this.xfG4.snrco2 < 700) {
          zslevel = 0
        } else if (this.xfG4.snrco2 < 1000) {
          zslevel = 1
        } else if (this.xfG4.snrco2 < 1500) {
          zslevel = 2
        } else {
          zslevel = 3
        }
        if (this.xfG4['snrpm2.5'] < 25) {
          yslevel = 0
        } else if (this.xfG4['snrpm2.5'] < 37.5) {
          yslevel = 1
        } else if (this.xfG4['snrpm2.5'] < 75) {
          yslevel = 2
        } else {
          yslevel = 3
        }
        if (Math.abs(this.xfG4.innertemp - 26) <= 2) {
          templevel = 0
        } else if (Math.abs(this.xfG4.innertemp - 26) <= 4) {
          templevel = 1
        } else if (Math.abs(this.xfG4.innertemp - 26) <= 6) {
          templevel = 2
        } else {
          templevel = 3
        }
        if (this.gdhns.snrhumi >= 40 && this.gdhns.snrhumi <= 60) {
          humidlevel = 0
        } else if (this.gdhns.snrhumi >= 30 && this.gdhns.snrhumi <= 70) {
          humidlevel = 1
        } else if (this.gdhns.snrhumi >= 20 && this.gdhns.snrhumi <= 80) {
          humidlevel = 2
        } else {
          humidlevel = 3
        }
        if (this.xfG4.filterAused <= 60) {
          yxlevel = 0
        } else if (this.xfG4.filterAused <= 105) {
          yxlevel = 1
        } else if (this.xfG4.filterAused <= 150) {
          yxlevel = 2
        } else {
          yxlevel = 3
        }
      } else if(!this.qlg.hexagon3) {
        if (this.qlg.snrco2 < 700) {
          zslevel = 0
        } else if (this.qlg.snrco2 < 1000) {
          zslevel = 1
        } else if (this.qlg.snrco2 < 1500) {
          zslevel = 2
        } else {
          zslevel = 3
        }
     
        if (this.qlg['snrpm2.5'] < 25) {
          yslevel = 0
        } else if (this.qlg['snrpm2.5'] < 37.5) {
          yslevel = 1
        } else if (this.qlg['snrpm2.5'] < 75) {
          yslevel = 2
        } else {
          yslevel = 3
        }

        if (Math.abs(this.qlg.snrtemp - 26) <= 2) {
          templevel = 0
        } else if (Math.abs(this.qlg.snrtemp - 26) <= 4) {
          templevel = 1
        } else if (Math.abs(this.qlg.snrtemp - 26) <= 6) {
          templevel = 2
        } else {
          templevel = 3
        }


        if (this.qlg.snrhumi >= 40 && this.qlg.snrhumi <= 60) {
          humidlevel = 0
        } else if (this.qlg.snrhumi >= 30 && this.qlg.snrhumi <= 70) {
          humidlevel = 1
        } else if (this.qlg.snrhumi >= 20 && this.qlg.snrhumi <= 80) {
          humidlevel = 2
        } else {
          humidlevel = 3
        }
   

        if (this.dehum.filterAused <= 60) {
          yxlevel = 0
        } else if (this.dehum.filterAused <= 105) {
          yxlevel = 1
        } else if (this.dehum.filterAused / 30 <= 150) {
          yxlevel = 2
        } else {
          yxlevel = 3
        }
 
      }
        colorlevel = Math.max(...[zslevel, yslevel, templevel, humidlevel, yxlevel, zxlevel])

        if (colorlevel <= 1) {
          ctx.strokeStyle = '#41BB79'
        } else if (colorlevel == 2) {
          ctx.strokeStyle = '#F4C01C'
        } else {
          ctx.strokeStyle = '#E0510A'
        }
      

      ctx.lineWidth = 2
      ctx.moveTo(zslist[zslevel][0][0], zslist[zslevel][0][1])
      ctx.lineTo(zslist[zslevel][1][0], zslist[zslevel][1][1])
      ctx.lineTo(humidList[humidlevel][0][0], humidList[humidlevel][0][1])
      ctx.lineTo(humidList[humidlevel][1][0], humidList[humidlevel][1][1])
      ctx.lineTo(zxList[zxlevel][0][0], zxList[zxlevel][0][1])
      ctx.lineTo(zxList[zxlevel][1][0], zxList[zxlevel][1][1])
      ctx.lineTo(yxList[yxlevel][0][0], yxList[yxlevel][0][1])
      ctx.lineTo(yxList[yxlevel][1][0], yxList[yxlevel][1][1])
      ctx.lineTo(tempList[templevel][0][0], tempList[templevel][0][1])
      ctx.lineTo(tempList[templevel][1][0], tempList[templevel][1][1])
      ctx.lineTo(ysList[yslevel][0][0], ysList[yslevel][0][1])
      ctx.lineTo(ysList[yslevel][1][0], ysList[yslevel][1][1])
      ctx.lineTo(zslist[zslevel][0][0], zslist[zslevel][0][1])
      ctx.stroke()
    },
    qlgChange (command) {
      this.qlg = command
      this.draw()
      this.$forceUpdate()
    },
    heatpumpChange (command) {
      this.heatpump = command
      this.$forceUpdate()
      Vue.axios.post('/api/cchv/power/query', {deviceid: this.acb.innerid || this.heatpump.innerid}).then((res) => {
            if (res.data.errcode == 0) {
              this.power = res.data.msgbody
              this.$forceUpdate()
            }
          })
      
    },
    showErrorList: function () {},
    calcHanZhi: function (t, h) {
      return Calcu_02(t, h, 101.325).h
    },
    calcHsl: function (t, h) {
      return Calcu_02(t, h, 101.325).d
    },
    calcLuDian: function (t, h) {
      return Calcu_02(t, h, 101.325).td
    },
    calcRate (v1, v2, v3) {
      if (v1 - v3 == 0) {
        return 85
      }
      let val = Math.round(((v1 - v2) / (v1 - v3)) * 100)
      if (val > 85) {
        return 85
      } else if (val < 35) {
        return 35
      } else {
        return isNaN(val) ? ' --' : val
      }
    },
    calcRate2 (v1, v2) {
      return Math.round((v1 / v2) * 1000) / 10
    },
    getDpText: function (device, tag) {
      if (device.dplist) {
        let dp = device.dplist.filter((d) => {
          return d.name == tag
        })
        if (dp && dp.length > 0) {
          let t = dp[0].options.filter((o) => {
            return o.value == device[tag]
          })
          if (t && t.length > 0) {
            return t[0].text
          } else {
            return '--'
          }
        } else {
          return '--'
        }
      } else {
        return '--'
      }
    }
  }
}
function loadEcharts (data) {
  return {
    tooltip: {// 拐点提示框
      trigger: 'axis'
    },
    color: ['#EF5327','#15a2d0'],
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: data.map(d=>{return d.x}),
      axisLine: {
        show: true,
        lineStyle: { color: '#545454' }
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#929292'
        // interval: z,
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dotted',
          color: '#545454'
        }
      }
    },
    yAxis: [{
      type: 'value',
      position: 'left',
      name: '设备耗电',
      // nameGap: 0,
      nameTextStyle: {// name 样式
        color: '#EF5327',
        fontSize: 12,

        padding: [0, 0, 0, 0]
      },
      // 刻度线样式
      axisLabel: {
        color: '#929292'
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#545454'
        }
      }
    },{
      type: 'value',
      position: 'right',
      name: '室外气温',
      // nameGap: 0,
      nameTextStyle: {// name 样式
        color: '#15a2d0',
        fontSize: 12,
        padding: [0, 0, 0, 0]
      },
      // 刻度线样式
      axisLabel: {
        color: '#929292'
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: '#545454'
        }
      }
    } ],
    series: [{// 左折线图 电量
      name: '设备耗电',
      data: data.map(d=>{return d.y}),
      smooth: false, // 修改折线为曲线
      type: 'line'
    },{// 左折线图 电量
      name: '室外气温',
      data: data.map(d=>{return Math.round(d.y1) }),
      smooth: false, // 修改折线为曲线
      type: 'line',
       yAxisIndex: 1
    } ],
    // 调整表格两边空白的区域
    grid: {
      left: '7%',
      top: '15%',
      right: '7%',
      bottom: '10%'
    }
  }
}
Date.prototype.Format = function (formatStr) {
  var str = formatStr
  var Week = ['日', '一', '二', '三', '四', '五', '六']

  str = str.replace(/yyyy|YYYY/, this.getFullYear())
  str = str.replace(
    /yy|YY/,
    this.getYear() % 100 > 9
      ? (this.getYear() % 100).toString()
      : '0' + (this.getYear() % 100)
  )

  str = str.replace(
    /MM/,
    this.getMonth() > 8 ? this.getMonth() + 1 : '0' + (this.getMonth() + 1)
  )
  str = str.replace(/M/g, this.getMonth())

  str = str.replace(/w|W/g, Week[this.getDay()])

  str = str.replace(
    /dd|DD/,
    this.getDate() > 9 ? this.getDate().toString() : '0' + this.getDate()
  )
  str = str.replace(/d|D/g, this.getDate())

  str = str.replace(
    /hh|HH/,
    this.getHours() > 9 ? this.getHours().toString() : '0' + this.getHours()
  )
  str = str.replace(/h|H/g, this.getHours())
  str = str.replace(
    /mm/,
    this.getMinutes() > 9
      ? this.getMinutes().toString()
      : '0' + this.getMinutes()
  )
  str = str.replace(/m/g, this.getMinutes())

  str = str.replace(
    /ss|SS/,
    this.getSeconds() > 9
      ? this.getSeconds().toString()
      : '0' + this.getSeconds()
  )
  str = str.replace(/s|S/g, this.getSeconds())

  return str
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div {
  box-sizing: border-box;
}
.text {
  color: #929292;
  height: 16px;
  line-height: 16px;
}

.value {
  color: #eca714;
  height: 16px;
  line-height: 16px;
}

.text_big {
  color: #929292;
  height: 20px;
  line-height: 20px;
}

.value_big {
  color: #eca714;
  height: 20px;
  line-height: 20px;
  text-align: right;
}
.value_big_1 {
  color: #929292;
  height: 20px;
  line-height: 20px;
  text-align: right;
}
.value_big_2 {
  /* color: #eca714;
  height: 20px;
  line-height: 20px; */
  text-align: left;
}
.anniu >>> .el-button--mini, .el-button--mini.is-round {
  padding: 0;
}
.anniu >>> .el-button.is-round {
  padding: 0;
}
.anniu .but {
  padding: 2px;
  width: 3rem;
  height: 1.3rem;
  text-align: center;

  position: absolute;
  top: 110px;
  right: 23.5%;
}
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background-color: #0c0404;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #0c0404;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: gray;
}
.aler >>> .el-alert__description {
  margin: 0;
}
.aler >>> .el-alert__content {
  padding: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Devices/Index.vue